/**
 * JavaScript personnalise pour Nicha Paris
 * BUILD: 2026-06-03-fix45
 */

/* Bootstrap pierres (homepage) — s'exécute même si le reste du fichier est incomplet */
(function nichaPierresBootstrap() {
  const SECTION = 'shopify-section-template--30374607421772__tsapb_ce7789ea_8wFhFr';
  const chaineDescHtml =
    '<span class="nicha-pierres-line">La Rhyolite apaise l\u2019esprit, éloigne les doutes</span><span class="nicha-pierres-line">et invite à avancer avec confiance.</span><span class="nicha-pierres-line">Idéale pour les Taureaux, Lions et Vierges.</span>';
  const chaineDescHtmlEn =
    '<span class="nicha-pierres-line">Rhyolite soothes the mind, quiets self-doubt,</span><span class="nicha-pierres-line">and inspires confidence in every step forward.</span><span class="nicha-pierres-line">Ideal for Taurus, Leo, and Virgo.</span>';
  const collierDescHtml =
    '<span class="nicha-pierres-line">L\u2019Améthyste stimule la créativité,</span><span class="nicha-pierres-line">nourrit l\u2019imagination et favorise la clarté d\u2019esprit.</span><span class="nicha-pierres-line">Idéale pour les Sagittaires, Verseaux et Capricornes.</span>';
  const collierDescHtmlEn =
    '<span class="nicha-pierres-line">Amethyst inspires creativity,</span><span class="nicha-pierres-line">fuels the imagination, and encourages clarity of mind.</span><span class="nicha-pierres-line">Ideal for Sagittarius, Aquarius, and Capricorn.</span>';
  const DESCS = [
    {
      test: /cha[iîï]ne|removable chain/i,
      html: chaineDescHtml,
      htmlEn: chaineDescHtmlEn,
    },
    {
      test: /collier|removable necklace/i,
      html: collierDescHtml,
      htmlEn: collierDescHtmlEn,
    },
  ];
  const isEn = () => {
    const locale = (window.Shopify?.locale || document.documentElement.lang || 'fr').toLowerCase();
    return locale === 'en' || locale.startsWith('en-');
  };
  const isChain = (t) => /cha[iîï]ne|removable chain/i.test(t || '');
  const isCollier = (t) => /collier|removable necklace/i.test(t || '');
  const injectCss = () => {
    if (document.getElementById('nicha-pierres-bootstrap-css')) return;
    const s = document.createElement('style');
    s.id = 'nicha-pierres-bootstrap-css';
    s.textContent = `
      #${SECTION} .VtlsValueIconsBlock__Heading{margin-bottom:.85rem!important}
      #${SECTION} .VtlsValueIconsBlock__Description{margin-top:.9rem!important;line-height:1.4!important;text-align:center!important;display:block!important}
        #${SECTION} .VtlsValueIconsBlock__Description.nicha-pierres-lines br{display:block!important;content:''!important;margin:0!important}
        #${SECTION} .VtlsValueIconsBlock__Description.nicha-pierres-lines .nicha-pierres-line{display:block!important;line-height:1.4!important;white-space:nowrap!important}
        #${SECTION} .nicha-pierres-block--collier .VtlsValueIconsBlock__Description.nicha-pierres-lines,#${SECTION} .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description.nicha-pierres-lines{max-width:min(100%,36rem)!important;min-width:0!important;width:max-content!important;margin-left:auto!important;margin-right:auto!important}
        @media(max-width:991px){#${SECTION} .nicha-pierres-block--collier .VtlsValueIconsBlock__Description.nicha-pierres-lines,#${SECTION} .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description.nicha-pierres-lines{font-size:clamp(.72rem,2.75vw,.82rem)!important;max-width:calc(100vw - 2rem)!important}}
      @media(min-width:992px){
        #${SECTION} .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description,#${SECTION} .nicha-pierres-block--collier .VtlsValueIconsBlock__Description,#${SECTION} .VtlsValueIconsBlock .VtlsValueIconsBlock__Description.nicha-pierres-lines{min-width:20rem!important;max-width:28rem!important}
        #${SECTION} .VtlsValueIconsBlock:has(.VtlsValueIconsBlock__Heading) .VtlsValueIconsBlock__Description{font-size:inherit!important}
      }
    `;
    document.head.appendChild(s);
  };
  const run = () => {
    const path = (location.pathname || '/').replace(/\/+$/, '') || '/';
    if (!(document.body.classList.contains('template-index') || path === '/' || /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path))) return;
    injectCss();
    const root = document.querySelector(`#${SECTION} .VtlsValueIcons`) ||
      [...document.querySelectorAll('#MainContent .VtlsValueIcons')].find(
        (el) => isChain(el.textContent) || isCollier(el.textContent)
      );
    if (!root) return;
    root.querySelectorAll('.VtlsValueIconsBlock').forEach((block) => {
      const h = block.querySelector('.VtlsValueIconsBlock__Heading');
      const p = block.querySelector('.VtlsValueIconsBlock__Description');
      if (!h || !p) return;
      const preset = DESCS.find((d) => d.test.test(h.textContent || ''));
      if (!preset) return;
      if (isCollier(h.textContent || '')) block.classList.add('nicha-pierres-block--collier');
      if (isChain(h.textContent || '')) block.classList.add('nicha-pierres-block--chaine');
      p.classList.add('nicha-pierres-lines');
      p.innerHTML = isEn() && preset.htmlEn ? preset.htmlEn : preset.html;
    });
  };
  const boot = () => { run(); [300, 1200, 4000].forEach((ms) => setTimeout(run, ms)); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', run);
})();

(function() {
  'use strict';

  if (window.NichaCustomInitialized) return;
  window.NichaCustomInitialized = true;
  window.NICHA_CUSTOM_BUILD = '2026-06-03-fix45';

  // ============================================
  // ANIMATIONS AU SCROLL
  // ============================================
  
  const initScrollAnimations = () => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('nicha-fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.nicha-animate-on-scroll').forEach(el => {
      observer.observe(el);
    });
  };

  // ============================================
  // CALCULATEUR DE DÉLAI PRÉ-COMMANDE
  // ============================================
  
  const initPreorderCalculator = () => {
    const preorderElements = document.querySelectorAll('[data-preorder-days]');
    
    preorderElements.forEach(element => {
      const days = parseInt(element.dataset.preorderDays, 10);
      if (isNaN(days)) return;
      
      const today = new Date();
      const deliveryDate = new Date(today);
      deliveryDate.setDate(today.getDate() + days);
      
      const options = { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
      };
      const formattedDate = deliveryDate.toLocaleDateString('fr-FR', options);
      
      element.textContent = `Livraison prévue le ${formattedDate}`;
    });
  };

  // ============================================
  // GALERIE PRODUIT — cadre hauteur uniforme (annule padding-top Dawn inline)
  // ============================================

  const NICHA_PRODUCT_MEDIA_FRAME_ID = 'nicha-product-media-frame-css';

  const injectProductMediaFrameStyles = () => {
    if (document.getElementById(NICHA_PRODUCT_MEDIA_FRAME_ID)) return;
    const style = document.createElement('style');
    style.id = NICHA_PRODUCT_MEDIA_FRAME_ID;
    style.textContent = `
      media-gallery.product__media-gallery,
      .product__media-gallery {
        --nicha-product-media-h: auto;
      }
      media-gallery.product__media-gallery .product__media-list,
      .product__media-gallery slider-component .product__media-list,
      media-gallery.product__media-gallery .product__media-item.is-active,
      .product__media-gallery slider-component .product__media-item.is-active {
        min-height: var(--nicha-product-media-h, auto) !important;
      }
      media-gallery.product__media-gallery .product__media-item.is-active,
      .product__media-gallery slider-component .product__media-item.is-active {
        min-height: var(--nicha-product-media-h, auto) !important;
      }
      media-gallery.product__media-gallery .product__media-item .product__media,
      media-gallery.product__media-gallery .product__media-item .product__media.global-media-settings,
      media-gallery.product__media-gallery .product__media-item modal-opener,
      media-gallery.product__media-gallery .product__media-item .product__modal-opener,
      .product__media-gallery slider-component .product__media-item .product__media,
      .product__media-gallery slider-component .product__media-item .product__media.global-media-settings,
      .product__media-gallery slider-component .product__media-item modal-opener,
      .product__media-gallery slider-component .product__media-item .product__modal-opener,
      section.page-width[class*="main-padding"] media-gallery .product__media-item.is-active .product__media,
      section.page-width[class*="main-padding"] .product__media-gallery .product__media-item.is-active .product__media {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        aspect-ratio: unset !important;
        width: 100% !important;
        height: var(--nicha-product-media-h, auto) !important;
        min-height: var(--nicha-product-media-h, auto) !important;
        max-height: var(--nicha-product-media-h, auto) !important;
        position: relative !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
      }
      @media (max-width: 749px) {
        media-gallery.product__media-gallery .product__media-item .product__media,
        .product__media-gallery slider-component .product__media-item .product__media,
        section.page-width[class*="main-padding"] .product__media-item .product__media {
          height: var(--nicha-product-media-h, auto) !important;
          min-height: var(--nicha-product-media-h, auto) !important;
          max-height: var(--nicha-product-media-h, auto) !important;
        }
      }
      media-gallery.product__media-gallery .product__media-item .product__media img,
      media-gallery.product__media-gallery .product__media-item modal-opener img,
      media-gallery.product__media-gallery .product__media-item .product__modal-opener img,
      .product__media-gallery slider-component .product__media-item .product__media img,
      .product__media-gallery slider-component .product__media-item modal-opener img,
      section.page-width[class*="main-padding"] .product__media-item .product__media img {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
        object-fit: contain !important;
      }
    `;
    document.head.appendChild(style);
  };

  const initProductUniformMediaFrames = () => {
    const gallery = document.querySelector('.product__media-gallery, media-gallery.product__media-gallery');
    if (!gallery) return;
    injectProductMediaFrameStyles();

    const applyFrameToEl = (el, frameH) => {
      if (!el) return;
      el.style.setProperty('padding-top', '0', 'important');
      el.style.setProperty('padding-bottom', '0', 'important');
      el.style.setProperty('height', frameH, 'important');
      el.style.setProperty('min-height', frameH, 'important');
      el.style.setProperty('max-height', frameH, 'important');
      el.style.setProperty('aspect-ratio', 'unset', 'important');
      el.style.setProperty('position', 'relative', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
    };

    const apply = () => {
      const wrapper = document.querySelector('.product__media-wrapper, .grid__item.product__media-wrapper');
      const list = gallery.querySelector('.product__media-list, ul.product__media-list');
      const activeItem = gallery.querySelector('.product__media-item.is-active');
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const w =
        (desktop && activeItem?.clientWidth) ||
        list?.clientWidth ||
        wrapper?.clientWidth ||
        gallery.clientWidth;
      if (!w || w < 40) return;

      const frameH = `${Math.round(w * (4 / 3))}px`;
      document.documentElement.style.setProperty('--nicha-product-media-h', frameH);
      gallery.style.setProperty('--nicha-product-media-h', frameH);

      const items = desktop
        ? [...gallery.querySelectorAll('.product__media-item.is-active')]
        : [...gallery.querySelectorAll('.product__media-item')];

      items.forEach((item) => {
        applyFrameToEl(item, frameH);
        item.querySelectorAll(
          '.product__media, .product__media.global-media-settings, modal-opener, .product__modal-opener, .deferred-media'
        ).forEach((el) => applyFrameToEl(el, frameH));
        item.querySelectorAll('img').forEach((img) => {
          img.style.setProperty('position', 'absolute', 'important');
          img.style.setProperty('inset', '0', 'important');
          img.style.setProperty('width', '100%', 'important');
          img.style.setProperty('height', '100%', 'important');
          img.style.setProperty('object-fit', 'contain', 'important');
        });
      });
    };

    if (gallery.dataset.nichaMediaUniform !== '1') {
      gallery.dataset.nichaMediaUniform = '1';
      apply();
      window.addEventListener('resize', () => setTimeout(apply, 80));
      if (typeof MutationObserver !== 'undefined') {
        const mo = new MutationObserver(() => setTimeout(apply, 50));
        mo.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      }
    } else {
      apply();
    }
  };

  window.NichaApplyProductMediaFrames = initProductUniformMediaFrames;

  // ============================================
  // LOUPE / MODAL IMAGE PRODUIT (fallback si le slider bloque les clics)
  // ============================================

  const initProductMainGallerySlider = () => {
    if (!document.querySelector('.product__media-gallery')) return;

    const viewer =
      document.querySelector('slider-component[id^="GalleryViewer"]') ||
      document.querySelector('.product__media-gallery > slider-component.slider-mobile-gutter');
    if (!viewer || viewer.dataset.nichaSliderBound === '1') return;

    const mediaGallery = document.querySelector('media-gallery.product__media-gallery');
    const getSlides = () => [...viewer.querySelectorAll('.product__media-item')];

    const getActiveIndex = () => {
      const slides = getSlides();
      let idx = slides.findIndex((s) => s.classList.contains('is-active'));
      if (idx < 0) idx = 0;
      return idx;
    };

    const activateMediaId = (mediaId) => {
      if (!mediaId) return false;

      if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
        try {
          mediaGallery.setActiveMedia(mediaId, false);
          return true;
        } catch (err) {
          /* noop */
        }
      }

      const thumbItem = document.querySelector(`.thumbnail-list__item[data-target="${mediaId}"]`);
      const thumbBtn = thumbItem?.querySelector('button.thumbnail') || thumbItem;
      if (thumbBtn) {
        thumbBtn.click();
        return true;
      }

      const slides = getSlides();
      const targetIdx = slides.findIndex((s) => s.dataset.mediaId === mediaId);
      if (targetIdx < 0) return false;

      slides.forEach((slide, idx) => {
        const active = idx === targetIdx;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('hidden');
        else slide.setAttribute('hidden', '');
      });

      document.querySelectorAll('.thumbnail-list__item').forEach((item) => {
        const isMatch = item.getAttribute('data-target') === mediaId;
        item.classList.toggle('is-active', isMatch);
        const btn = item.querySelector('button.thumbnail');
        if (btn) {
          if (isMatch) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        }
      });

      const current = viewer.querySelector('.slider-counter--current');
      if (current) current.textContent = String(targetIdx + 1);
      return true;
    };

    const goToIndex = (index) => {
      const slides = getSlides();
      if (!slides.length) return;
      const i = ((index % slides.length) + slides.length) % slides.length;
      activateMediaId(slides[i].dataset.mediaId);
      setTimeout(initProductUniformMediaFrames, 0);
    };

    const onNavClick = (e, delta) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      goToIndex(getActiveIndex() + delta);
    };

    viewer.querySelectorAll('.slider-button--prev, .slider-button[name="previous"]').forEach((btn) => {
      btn.addEventListener('click', (e) => onNavClick(e, -1), true);
    });
    viewer.querySelectorAll('.slider-button--next, .slider-button[name="next"]').forEach((btn) => {
      btn.addEventListener('click', (e) => onNavClick(e, 1), true);
    });

    viewer.dataset.nichaSliderBound = '1';
    initThumbnailStripSlider();
  };

  const initThumbnailStripSlider = () => {
    const thumbSlider =
      document.querySelector('slider-component[id^="GalleryThumbnails"]') ||
      document.querySelector('.product__media-gallery .thumbnail-slider slider-component');
    const thumbStrip =
      thumbSlider?.closest('.thumbnail-slider') ||
      document.querySelector('.product__media-gallery .thumbnail-slider');
    if (!thumbSlider && !thumbStrip) return;
    const boundRoot = thumbStrip || thumbSlider;
    if (boundRoot.dataset.nichaThumbBound === '1') return;

    const mediaGallery = document.querySelector('media-gallery.product__media-gallery');
    const listRoot = thumbSlider || thumbStrip;
    const getItems = () => [...listRoot.querySelectorAll('.thumbnail-list__item')];

    const getActiveIndex = () => {
      const items = getItems();
      let idx = items.findIndex(
        (item) =>
          item.classList.contains('is-active') ||
          item.querySelector('button.thumbnail[aria-current="true"]')
      );
      return idx < 0 ? 0 : idx;
    };

    const activateAt = (index) => {
      const items = getItems();
      if (!items.length) return;
      const i = ((index % items.length) + items.length) % items.length;
      const mediaId = items[i].getAttribute('data-target');
      const btn = items[i].querySelector('button.thumbnail');

      if (mediaId && mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
        try {
          mediaGallery.setActiveMedia(mediaId, false);
        } catch (err) {
          if (btn) btn.click();
        }
      } else if (btn) {
        btn.click();
      }

      items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      setTimeout(initProductUniformMediaFrames, 0);
    };

    const onNav = (e, delta) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const step = Math.max(1, parseInt(e.currentTarget?.dataset?.step || '1', 10) || 1);
      activateAt(getActiveIndex() + delta * step);
    };

    const bindNav = (root, selector, delta) => {
      if (!root) return;
      root.querySelectorAll(selector).forEach((btn) => {
        if (btn.dataset.nichaThumbNav === '1') return;
        btn.dataset.nichaThumbNav = '1';
        btn.addEventListener('click', (e) => onNav(e, delta), true);
      });
    };

    const prevSel =
      ':scope > .slider-button--prev, :scope > .slider-button[name="previous"], :scope > .slider-buttons .slider-button--prev, :scope > .slider-buttons .slider-button[name="previous"]';
    const nextSel =
      ':scope > .slider-button--next, :scope > .slider-button[name="next"], :scope > .slider-buttons .slider-button--next, :scope > .slider-buttons .slider-button[name="next"]';

    bindNav(thumbStrip, prevSel, -1);
    bindNav(thumbStrip, nextSel, 1);
    if (thumbSlider && thumbSlider !== thumbStrip) {
      bindNav(thumbSlider, prevSel, -1);
      bindNav(thumbSlider, nextSel, 1);
    }

    boundRoot.dataset.nichaThumbBound = '1';
  };

  const initProductMediaModalFix = () => {
    if (document.body.dataset.nichaModalFix) return;
    document.body.dataset.nichaModalFix = '1';
    // Le slider bloque les clics : on écoute le modal-opener (zone image) pour ouvrir la modale
    document.addEventListener('click', (e) => {
      if (e.target.closest?.('.product__media-gallery .slider-button, .thumbnail-slider .slider-button')) return;
      const opener = e.target.closest?.('modal-opener.product__modal-opener');
      if (!opener) return;
      const modalId = opener.getAttribute('data-modal');
      if (!modalId) return;
      const modal = document.querySelector(modalId);
      if (!modal || typeof modal.show !== 'function') return;
      e.preventDefault();
      e.stopPropagation();
      const toggle = opener.querySelector('.product__media-toggle');
      modal.show(toggle || opener);
    }, true);
  };

  // ============================================
  // GALERIE PRODUIT AMÉLIORÉE
  // ============================================
  
  const initProductGallery = () => {
    const gallery = document.querySelector('.nicha-product-gallery');
    if (!gallery) return;
    
    const mainImage = gallery.querySelector('.nicha-product-gallery__main img');
    const thumbnails = gallery.querySelectorAll('.nicha-product-gallery__thumb');
    
    if (!mainImage || thumbnails.length === 0) return;
    
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const newSrc = thumb.dataset.fullImage || thumb.href;
        
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 150);
        
        thumbnails.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  };

  // ============================================
  // COMPTEUR DE STOCK/URGENCE
  // ============================================
  
  const initStockCounter = () => {
    const counters = document.querySelectorAll('[data-stock-count]');
    
    counters.forEach(counter => {
      const stock = parseInt(counter.dataset.stockCount, 10);
      if (isNaN(stock) || stock <= 0) return;
      
      if (stock <= 5) {
        counter.classList.add('low-stock');
        counter.textContent = `Plus que ${stock} en stock`;
      } else {
        counter.textContent = `${stock} en stock`;
      }
    });
  };

  // ============================================
  // SMOOTH SCROLL POUR ANCRES
  // ============================================
  
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#' || href === '#!') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  };

  // ============================================
  // LAZY LOADING DES IMAGES
  // ============================================
  
  const initLazyLoading = () => {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              img.classList.add('loaded');
            }
            observer.unobserve(img);
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  };

  // ============================================
  // OPTIMISATION MOBILE MENU
  // ============================================
  
  const initMobileMenu = () => {
    const menuToggle = document.querySelector('.nicha-mobile-menu-toggle');
    const menu = document.querySelector('.nicha-mobile-menu');
    
    if (!menuToggle || !menu) return;
    
    menuToggle.addEventListener('click', () => {
      menu.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
    
    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target) && !menuToggle.contains(e.target)) {
        menu.classList.remove('active');
        document.body.classList.remove('menu-open');
      }
    });
  };

  // ============================================
  // SMARTSIZE: BOUTON FACTICE ALIGNÉ AVEC "TAILLE"
  //
  // Principe :
  //   1. Le bloc Smartsize reste dans le DOM, on ne le déplace pas.
  //      On le cache avec display:none pour que ses gestionnaires
  //      de clic restent actifs.
  //   2. On ajoute un bouton factice « Guide des tailles » à droite
  //      du titre « Taille » dans la légende du fieldset.
  //   3. Au clic sur le bouton factice, on déclenche click() sur le
  //      vrai déclencheur Smartsize → le guide s'ouvre normalement.
  // ============================================

  const findSmartsizeTrigger = () => {
    const byId = document.querySelector('#opensize');
    if (byId) return byId;

    const byTrigger = document.querySelector('.smartsize-trigger, .smartsize-trigger--inline');
    if (byTrigger) return byTrigger;

    const byIcon = document.querySelector('.smartsize-button__icon');
    if (byIcon) return byIcon.closest('a, button, span, div') || byIcon;

    return Array.from(document.querySelectorAll('a, button, span, div'))
      .find((el) => (el.textContent || '').trim().toLowerCase() === 'guide des tailles') || null;
  };

  const hideSmartsizeBlock = () => {
    const container = document.querySelector('#sizefox-container');
    if (!container) return;

    // Masquer uniquement le bloc app Shopify (ancêtre sûr)
    // Ne jamais remonter au-delà sans classe explicite pour éviter de cacher les variantes
    const appBlock = container.closest('.shopify-app-block') ||
                     container.closest('.shopify-block');
    if (appBlock) {
      appBlock.style.setProperty('display', 'none', 'important');
    } else {
      // Pas de bloc app trouvé : masquer seulement le container lui-même
      container.style.setProperty('display', 'none', 'important');
    }

    document.body.classList.add('nicha-smartsize-fake-added');
  };

  const addSmartsizeFakeButton = (slot) => {
    if (!slot) return;
    hideSmartsizeBlock();
    if (slot.querySelector('.nicha-smartsize-fake-btn')) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nicha-smartsize-fake-btn';
    btn.innerHTML = '<img class="smartsize-button__icon" src="https://cdn.shopify.com/s/files/1/0848/1321/8088/files/ruler.svg?v=1736774771" alt="" style="width:auto;height:1em;margin-right:0.5rem;vertical-align:middle;"><span>Guide des tailles</span>';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const t = findSmartsizeTrigger();
      if (t) t.click();
    });
    slot.appendChild(btn);
    document.body.classList.add('nicha-smartsize-fake-added');
  };

  const watchAndHideSmartsizeBlock = () => {
    // Masquer immédiatement si déjà présent
    hideSmartsizeBlock();

    // Observer pour le cacher dès qu'il apparaît dans le DOM
    if (document.body && document.body.dataset.sizefoxHideObserver !== 'true') {
      document.body.dataset.sizefoxHideObserver = 'true';
      const hideObserver = new MutationObserver(() => {
        if (document.querySelector('#sizefox-container')) {
          hideSmartsizeBlock();
        }
      });
      hideObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Réappliquer plusieurs fois pour couvrir le chargement tardif
    [200, 500, 1000, 2000, 3000].forEach((d) => setTimeout(hideSmartsizeBlock, d));
  };

  const moveSmartsizeIntoLegend = () => {
    // Ne pas afficher le bouton Guide des tailles sur la collection bijoux
    if (isBijouxCollection()) return false;

    hideSmartsizeBlock();

    const variantBlocks = Array.from(document.querySelectorAll('.product-form__input'));
    if (variantBlocks.length === 0) return false;

    const labelMatch = (el) => {
      const text = (el.textContent || '').trim().toLowerCase();
      return text.includes('taille') || text.includes('size');
    };

    const targetBlock = variantBlocks.find((block) => {
      const label = block.querySelector('.form__label, legend.form__label');
      return label && labelMatch(label);
    }) || variantBlocks[0];

    if (!targetBlock) return false;
    targetBlock.classList.add('size-variant-block');

    const legendEl = targetBlock.querySelector('legend.form__label') || targetBlock.querySelector('legend');
    const labelEl = targetBlock.querySelector('.form__label');
    if (!legendEl && !labelEl) return false;

    if (legendEl) {
      legendEl.classList.add('sizefox-row', 'form__label');
      legendEl.style.cssText = 'display:flex;align-items:center;justify-content:space-between;width:100%;margin-bottom:0;padding-bottom:0;line-height:1;';

      let slot = legendEl.querySelector('.sizefox-slot');
      if (!slot) {
        slot = document.createElement('span');
        slot.className = 'sizefox-slot';
        slot.style.cssText = 'margin-left:auto;display:flex;align-items:center;flex-shrink:0;line-height:1;';
        legendEl.appendChild(slot);
      }
      addSmartsizeFakeButton(slot);

      // Réduire l'espace entre la legend et les boutons variantes.
      // La legend a 54px de hauteur (à cause du bouton) mais le fieldset n'a que 2px de padding-top.
      // L'espace visuel vient du padding-top (10px) des labels pill de Dawn.
      // On remonte le groupe de boutons en appliquant margin-top négatif sur le fieldset lui-même
      // MAIS seulement sur son padding interne via une translation de la legend vers le bas.
      // Solution retenue : margin-bottom négatif sur la legend pour "absorber" l'espace.
      if (!document.getElementById('nicha-pill-spacing')) {
        const s = document.createElement('style');
        s.id = 'nicha-pill-spacing';
        s.textContent = `
          fieldset.size-variant-block > legend {
            line-height: 1 !important;
          }
          fieldset.size-variant-block > legend .sizefox-slot {
            line-height: 1 !important;
          }
          fieldset.size-variant-block > legend .nicha-smartsize-fake-btn {
            line-height: 1 !important;
          }
        `;
        document.head.appendChild(s);
      }

      return true;
    }

    let row = targetBlock.querySelector('.sizefox-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'sizefox-row';
      row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;width:100%;';
      if (labelEl && labelEl.parentElement !== row) row.appendChild(labelEl);
      targetBlock.insertBefore(row, targetBlock.firstChild);
    }
    let slot = row.querySelector('.sizefox-slot');
    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'sizefox-slot';
      slot.style.cssText = 'margin-left:auto;display:flex;align-items:center;flex-shrink:0;';
      row.appendChild(slot);
    }
    addSmartsizeFakeButton(slot);
    return true;
  };

  const initSmartsizePlacement = () => {
    if (moveSmartsizeIntoLegend()) return;

    if (document.body && document.body.dataset.sizefoxObserver !== 'true') {
      document.body.dataset.sizefoxObserver = 'true';
      const observer = new MutationObserver(() => {
        moveSmartsizeIntoLegend();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  const retrySmartsizePlacement = (attempts = 20) => {
    if (attempts <= 0) return;
    moveSmartsizeIntoLegend();
    setTimeout(() => retrySmartsizePlacement(attempts - 1), 500);
  };

  // ============================================
  // CHAMP PERSONNALISÉ ALTERNATIF (SHOPIFY)
  // ============================================

  const normalizeText = (value) => {
    return (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  const isBijouxCollection = () => {
    const path = window.location.pathname || '';
    return /\/collections\/nos-bijoux(\/|$)/.test(path) || /\/products\/nos-bijoux(-|$)/.test(path);
  };

  const loadKlarnaScript = (callback) => {
    if (document.querySelector('script[src*="klarna"]') || window.Klarna) {
      if (callback) callback();
      return;
    }
    const clientId = window.NICHA_KLARNA_CLIENT_ID || '';
    if (!clientId) {
      if (!window.__nichaKlarnaWarned) {
        window.__nichaKlarnaWarned = true;
        console.warn(
          'Nicha: Klarna non chargé. Définissez window.NICHA_KLARNA_CLIENT_ID avec votre Client ID Klarna (portail marchand).'
        );
      }
      if (callback) callback();
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
    script.dataset.environment = window.NICHA_KLARNA_ENV || 'production';
    script.dataset.clientId = clientId;
    script.onload = () => { if (callback) callback(); };
    script.onerror = () => { if (callback) callback(); };
    document.head.appendChild(script);
  };

  const getProductPriceCents = () => {
    const priceEl = document.querySelector('.price__regular .price-item, [data-product-price], .product__price .price, [data-price]');
    if (!priceEl) return '';
    const text = (priceEl.textContent || priceEl.dataset.price || '').replace(/[^\d,.]/g, '').replace(',', '.');
    const num = parseFloat(text);
    if (isNaN(num)) return '';
    return Math.round(num * 100).toString();
  };

  const initKlarnaPlacement = () => {
    const buttonsBlock = document.querySelector('.product-form__buttons');
    if (!buttonsBlock) return;

    const addToCartEl = buttonsBlock.querySelector('.product-form__submit, button[type="submit"]') ||
      Array.from(buttonsBlock.querySelectorAll('button, [type="submit"]')).find((el) =>
        /ajouter|add|panier|cart/i.test(el.textContent || '')
      );
    const insertBeforeEl = addToCartEl ? (addToCartEl.closest('.product-form__submit') || addToCartEl) : buttonsBlock.lastElementChild;
    if (!insertBeforeEl) return;

    let placement = document.querySelector('klarna-placement');
    if (!placement) {
      placement = document.createElement('klarna-placement');
      placement.setAttribute('data-key', 'credit-promotion-badge');
      placement.setAttribute('data-locale', 'fr-FR');
    }
    const amount = getProductPriceCents();
    placement.setAttribute('data-purchase-amount', amount || '');

    let wrapper = document.querySelector('.nicha-klarna-placement-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'nicha-klarna-placement-wrapper';
    }
    if (!wrapper.contains(placement)) wrapper.appendChild(placement);
    if (!buttonsBlock.contains(wrapper) || wrapper.nextElementSibling !== insertBeforeEl) {
      wrapper.remove();
      buttonsBlock.insertBefore(wrapper, insertBeforeEl);
    }
  };

  const loadCardoFont = () => {
    if (document.querySelector('link[href*="Cardo"]') || document.querySelector('link[href*="cardo"]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Cardo:ital,wght@0,400;0,700;1,400&display=swap';
    document.head.appendChild(link);
  };

  const injectKlarnaStyles = () => {
    loadCardoFont();
    let style = document.getElementById('nicha-klarna-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'nicha-klarna-styles';
      document.head.appendChild(style);
    }
    style.textContent = `
      .nicha-klarna-placement-wrapper {
        width: 100%;
      }
      @media (min-width: 990px) {
        .nicha-klarna-placement-wrapper {
          margin-top: 0.5rem !important;
          margin-bottom: 1.25rem !important;
        }
      }
      klarna-placement {
        display: block;
        width: 100%;
        font-family: 'Cardo', Georgia, serif !important;
      }
      klarna-placement *,
      klarna-placement a,
      klarna-placement a:hover,
      klarna-placement a:visited,
      klarna-placement::part(osm-container),
      klarna-placement::part(osm-message) {
        font-family: 'Cardo', Georgia, serif !important;
      }
    `;
  };

  const injectKlarnaShadowStyles = () => {
    document.querySelectorAll('klarna-placement').forEach((el) => {
      if (el.shadowRoot && !el.shadowRoot.querySelector('#nicha-klarna-shadow-styles')) {
        const style = document.createElement('style');
        style.id = 'nicha-klarna-shadow-styles';
        style.textContent = `
          *, *::before, *::after, a, a:hover, a:visited, span {
            font-family: 'Cardo', Georgia, serif !important;
          }
        `;
        el.shadowRoot.prepend(style);
      }
    });
  };

  const findSizeFieldset = () => {
    const blocks = Array.from(document.querySelectorAll('.product-form__input, fieldset, [class*="variant"], variant-radios'));
    const hasSizeRadios = (block) => block.querySelectorAll('input[type="radio"]').length > 0;
    const legendMatch = (el) => {
      const text = (el.textContent || '').trim().toLowerCase();
      return text.includes('taille') || text.includes('size') || text.includes('mesures') || text.includes('measures');
    };
    const hasVosMesuresOption = (block) =>
      Array.from(block.querySelectorAll('label')).some((l) => {
        const n = normalizeText(l.textContent || '');
        return n.includes('vos mesures') || n.includes('your measures') || n.includes('made to your measures');
      });

    let found = blocks.find((block) => hasSizeRadios(block) && (() => {
      const label = block.querySelector('.form__label, legend, .form__label');
      return label && legendMatch(label);
    })());
    if (!found) {
      found = blocks.find((block) => hasSizeRadios(block) && hasVosMesuresOption(block));
    }
    return found || null;
  };

  const findCheckedSizeInput = () => {
    const sizeFieldset = findSizeFieldset();
    if (sizeFieldset) {
      const checked = sizeFieldset.querySelector('input[type="radio"]:checked');
      if (checked) return checked;
    }
    const all = Array.from(
      document.querySelectorAll('input[type="radio"][name*="Taille"]:checked, input[type="radio"][name*="Size"]:checked, input[type="radio"][name*="options"]:checked')
    );
    if (all.length > 0) {
      const visible = all.find((el) => el.offsetParent || el.getClientRects().length);
      return visible || all[0];
    }
    return document.querySelector('.product-form input[type="radio"]:checked');
  };

  const resolveFormFromInput = (inputEl) => {
    if (!inputEl) return null;
    if (inputEl.form) return inputEl.form;
    if (inputEl.getAttribute && inputEl.getAttribute('form')) {
      const formId = inputEl.getAttribute('form');
      return document.getElementById(formId);
    }
    return (inputEl.closest && inputEl.closest('form')) || null;
  };

  const findSizeContext = () => {
    const sizeFieldset = findSizeFieldset();
    if (sizeFieldset) {
      const form = sizeFieldset.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (form) return { form, anchorEl: sizeFieldset };
    }
    const forms = Array.from(
      document.querySelectorAll('.product-form form, form[action*="/cart/add"]')
    );
    if (forms.length === 0) return null;
    const labelMatch = (el) => {
      const text = (el.textContent || '').trim().toLowerCase();
      return text.includes('taille') || text.includes('size');
    };

    for (const form of forms) {
      const checked =
        form.querySelector('input[type="radio"][name*="Taille"]:checked') ||
        form.querySelector('input[type="radio"][name*="Size"]:checked') ||
        form.querySelector('input[type="radio"]:checked');
      if (checked) {
        const anchorEl =
          checked.closest('.product-form__input') ||
          checked.closest('fieldset') ||
          checked.closest('.product-form') ||
          checked.parentElement;
        if (anchorEl) return { form, anchorEl };
      }

      const variantBlocks = Array.from(form.querySelectorAll('.product-form__input'));
      if (variantBlocks.length === 0) continue;
      const fieldset =
        variantBlocks.find((block) => {
          const label = block.querySelector('.form__label, legend.form__label, legend');
          return label && labelMatch(label);
        }) || null;
      if (fieldset) return { form, anchorEl: fieldset };
    }

    return null;
  };

  const getSelectedSizeValue = (containerEl) => {
    if (!containerEl) return '';
    const checked =
      containerEl.matches && containerEl.matches('input[type="radio"]')
        ? containerEl
        : containerEl.querySelector('input[type="radio"]:checked');
    if (checked) {
      const directValue = (checked.value || '').trim();
      if (directValue) return directValue;
      const labelRoot =
        (containerEl.closest && containerEl.closest('form')) ||
        (containerEl.closest && containerEl.closest('fieldset')) ||
        document;
      let labelText = '';
      if (checked.id) {
        const labelByFor = labelRoot.querySelector(`label[for="${checked.id}"]`);
        if (labelByFor && labelByFor.textContent) labelText = labelByFor.textContent.trim();
      }
      if (!labelText && checked.closest) {
        const wrappingLabel = checked.closest('label');
        if (wrappingLabel && wrappingLabel.textContent) labelText = wrappingLabel.textContent.trim();
      }
      return (
        labelText ||
        checked.dataset.value ||
        checked.getAttribute('data-value') ||
        checked.value ||
        ''
      ).trim();
    }
    const select =
      containerEl.matches && containerEl.matches('select')
        ? containerEl
        : containerEl.querySelector('select');
    if (select) {
      const option = select.selectedOptions && select.selectedOptions[0];
      return (
        (option && option.textContent) ||
        select.value ||
        ''
      ).trim();
    }
    return '';
  };

  const cleanupMeasurementFields = (targetForm) => {
    const all = Array.from(document.querySelectorAll('.nicha-measurement-field'));
    if (all.length === 0) return null;

    const formId = targetForm && targetForm.id ? targetForm.id : '';
    let kept = null;
    if (targetForm) {
      const matching = formId
        ? all.filter((node) => node.dataset.nichaFormId === formId)
        : [];
      const inForm = all.filter((node) => targetForm.contains(node));
      if (inForm.length > 0) {
        kept = inForm[0];
        inForm.slice(1).forEach((node) => node.remove());
      }
      if (!kept && matching.length > 0) {
        kept = matching[0];
        matching.slice(1).forEach((node) => node.remove());
      }
      all
        .filter((node) => !targetForm.contains(node))
        .filter((node) => {
          if (!formId) return true;
          return node.dataset.nichaFormId !== formId;
        })
        .forEach((node) => node.remove());
    } else {
      kept = all[0];
      all.slice(1).forEach((node) => node.remove());
    }

    return kept;
  };

  const resolveFormElement = (context, checkedInput) => {
    const formFromContext =
      context &&
      context.form &&
      context.form.tagName &&
      context.form.tagName.toLowerCase() === 'form'
        ? context.form
        : null;
    if (formFromContext) return formFromContext;
    if (checkedInput && checkedInput.form) return checkedInput.form;
    if (checkedInput && checkedInput.getAttribute) {
      const formId = checkedInput.getAttribute('form');
      if (formId) {
        const byId = document.getElementById(formId);
        if (byId) return byId;
      }
    }
    if (context && context.anchorEl && context.anchorEl.getAttribute) {
      const formId = context.anchorEl.getAttribute('form');
      if (formId) {
        const byId = document.getElementById(formId);
        if (byId) return byId;
      }
    }
    if (context && context.anchorEl && context.anchorEl.closest) {
      const closest = context.anchorEl.closest('form');
      if (closest) return closest;
    }
    return document.querySelector('form[action*="/cart/add"]');
  };

  const ensureFormId = (form) => {
    if (!form) return null;
    const currentId = String(form.id || '');
    if (!currentId || currentId.includes('[object')) {
      form.id = `nicha-product-form-${Date.now()}`;
    }
    return form.id;
  };

  const getOutermostDisabledFieldset = (node) => {
    if (!node || !node.closest) return null;
    const nearest = node.closest('fieldset[disabled]');
    if (!nearest) return null;
    let outermost = nearest;
    let parent = nearest.parentElement;
    while (parent) {
      if (
        parent.tagName &&
        parent.tagName.toLowerCase() === 'fieldset' &&
        parent.hasAttribute('disabled')
      ) {
        outermost = parent;
      }
      parent = parent.parentElement;
    }
    return outermost;
  };

  const forceTextareaEditable = (wrapper) => {
    if (!wrapper) return;
    const textarea = wrapper.querySelector('textarea');
    if (!textarea) return;
    textarea.disabled = false;
    textarea.readOnly = false;
    textarea.removeAttribute('disabled');
    textarea.removeAttribute('readonly');
    textarea.tabIndex = 0;
    textarea.style.pointerEvents = 'auto';
    textarea.style.userSelect = 'text';
    textarea.style.webkitUserSelect = 'text';
    textarea.style.position = 'relative';
    textarea.style.zIndex = '2';
    wrapper.style.pointerEvents = 'auto';
    wrapper.style.position = 'relative';
    wrapper.style.zIndex = '2';
  };

  const ensureCustomMeasurementField = (context) => {
    if (!context || !context.form) return null;
    const form = resolveFormElement(context, findCheckedSizeInput()) || context.form;
    const anchorEl = context.anchorEl || form;

    const formId = ensureFormId(form);

    let wrapper =
      cleanupMeasurementFields(form) ||
      document.querySelector(
        formId ? `.nicha-measurement-field[data-nicha-form-id="${formId}"]` : '.nicha-measurement-field'
      ) ||
      form.querySelector('.nicha-measurement-field');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'nicha-measurement-field';
      wrapper.setAttribute('data-nicha-measurement', 'true');
      if (formId) {
        wrapper.dataset.nichaFormId = String(formId);
      }

      const label = document.createElement('label');
      label.setAttribute('for', 'nicha-measurements');
      label.textContent = isBijouxCollection()
        ? 'Votre bijou est fabriqué uniquement pour vous dans notre studio de Chantilly.'
        : 'Votre vêtement-bijou est fabriqué uniquement pour vous dans notre atelier aux portes de Paris. Indiquez toute mesure que vous souhaiteriez personnaliser.';

      const textarea = document.createElement('textarea');
      textarea.id = 'nicha-measurements';
      textarea.name = 'properties[Mensurations]';
      textarea.rows = 4;
      textarea.placeholder = isBijouxCollection()
        ? 'Longueur, diamètre souhaité…'
        : 'Tour de taille, tour de poitrine, tour de hanches, longueur souhaitée...';
      if (formId) {
        textarea.setAttribute('form', String(formId));
      }

      wrapper.appendChild(label);
      wrapper.appendChild(textarea);

      if (anchorEl && anchorEl.parentNode) {
        const disabledFieldset = getOutermostDisabledFieldset(anchorEl);
        const variantRadios =
          anchorEl.closest && anchorEl.closest('variant-radios');
        const insertAfterEl = variantRadios || disabledFieldset || anchorEl;
        const insertParent = insertAfterEl.parentNode;
        if (insertAfterEl.nextSibling) {
          insertParent.insertBefore(wrapper, insertAfterEl.nextSibling);
        } else {
          insertParent.appendChild(wrapper);
        }
      } else {
        form.appendChild(wrapper);
      }
    }

    if (wrapper) {
      if (formId) {
        wrapper.dataset.nichaFormId = String(formId);
      }
      const textarea = wrapper.querySelector('textarea');
      if (textarea && formId && textarea.getAttribute('form') !== formId) {
        textarea.setAttribute('form', String(formId));
      }
    }

    if (wrapper && wrapper.closest && wrapper.closest('fieldset[disabled]')) {
      const disabledFieldset = getOutermostDisabledFieldset(wrapper);
      const insertAfterEl = form;
      const insertParent = form.parentNode || (disabledFieldset && disabledFieldset.parentNode);
      if (insertParent && insertAfterEl) {
        if (insertAfterEl.nextSibling) {
          insertParent.insertBefore(wrapper, insertAfterEl.nextSibling);
        } else {
          insertParent.appendChild(wrapper);
        }
      }
    }

    forceTextareaEditable(wrapper);
    return wrapper;
  };

  const getCheckedSizeValueFromRoot = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    const radios = Array.from(
      scope.querySelectorAll('input[type="radio"]')
    );
    const checked = radios.find((input) => input && input.checked);
    if (!checked) return '';
    const directValue = (checked.value || '').trim();
    if (directValue) return directValue;
    if (checked.id) {
      const label =
        (scope.querySelector && scope.querySelector(`label[for="${checked.id}"]`)) ||
        document.querySelector(`label[for="${checked.id}"]`);
      if (label && label.textContent) return label.textContent.trim();
    }
    if (checked.closest) {
      const wrappingLabel = checked.closest('label');
      if (wrappingLabel && wrappingLabel.textContent) return wrappingLabel.textContent.trim();
    }
    return '';
  };

  const getCheckedSizeValueFromVisibleVariant = () => {
    const sizeFieldset = findSizeFieldset();
    if (sizeFieldset) {
      const value = getCheckedSizeValueFromRoot(sizeFieldset);
      if (value) return value;
    }
    const variants = Array.from(document.querySelectorAll('variant-radios'));
    const labelMatch = (el) => {
      const t = (el.textContent || '').trim().toLowerCase();
      return t.includes('taille') || t.includes('size');
    };
    for (const variant of variants) {
      const isVisible = variant.offsetParent || variant.getClientRects().length;
      if (!isVisible) continue;
      const label = variant.querySelector('.form__label, legend');
      if (label && !labelMatch(label)) continue;
      const value = getCheckedSizeValueFromRoot(variant);
      if (value) return value;
    }
    return '';
  };

  const getCurrentSizeValueFromDOM = () => {
    const visibleValue = getCheckedSizeValueFromVisibleVariant();
    if (visibleValue) return visibleValue;
    const checkedInput = findCheckedSizeInput();
    if (checkedInput) {
      const container = checkedInput.closest('fieldset') || checkedInput.closest('.product-form__input') || checkedInput;
      return getSelectedSizeValue(container);
    }
    return '';
  };

  const isCustomSizeValue = (normalized) => {
    const n = (normalized || '').replace(/[-_\s]/g, '').toLowerCase();
    const s = (normalized || '').toLowerCase();
    return s.includes('a vos mesures') || s.includes('vos mesures') || s.includes('sur mesure') ||
      s.includes('made to your measures') || s.includes('your measures') ||
      n.includes('avosmesures') || n.includes('madetoyourmeasures') ||
      s.includes('custom');
  };

  const findAVosMesuresInput = () => {
    const search = (root) => {
      const labels = root.querySelectorAll ? root.querySelectorAll('label') : [];
      for (const label of labels) {
        const norm = normalizeText(label.textContent || '').trim();
        if (norm.length > 80) continue;
        const isVosMesures = norm.includes('a vos mesures') || norm.includes('avosmesures') || norm.includes('vos mesures') ||
          norm.includes('made to your measures') || norm.includes('your measures');
        if (!isVosMesures) continue;
        let input = null;
        const forId = label.getAttribute('for');
        if (forId) input = document.getElementById(forId);
        if (!input && label.querySelector) input = label.querySelector('input[type="radio"]');
        if (!input && label.parentElement) {
          const parent = label.parentElement;
          if (parent.querySelector) input = parent.querySelector('input[type="radio"]');
        }
        if (input && input.type === 'radio') return input;
      }
      const withShadow = root.querySelectorAll ? root.querySelectorAll('variant-radios, variant-selects, [class*="variant"]') : [];
      for (const el of withShadow) {
        if (el.shadowRoot) {
          const found = search(el.shadowRoot);
          if (found) return found;
        }
      }
      return null;
    };
    return search(document.body);
  };

  const isAVosMesuresRadioChecked = () => {
    const input = findAVosMesuresInput();
    return input ? input.checked : false;
  };

  const bindAVosMesuresListeners = () => {
    const input = findAVosMesuresInput();
    if (!input || input.dataset.nichaBound === '1') return;
    input.dataset.nichaBound = '1';
    const handler = () => { updateCustomMeasurementField(); };
    input.addEventListener('change', handler);
    input.addEventListener('click', handler, true);
    const name = input.getAttribute('name');
    if (name) {
      const form = input.form || input.closest('form');
      const root = form || document;
      try {
        const siblings = root.querySelectorAll('input[type="radio"][name="' + CSS.escape(name) + '"]');
        siblings.forEach((r) => {
          if (r !== input) {
            r.addEventListener('change', handler);
            r.addEventListener('click', handler, true);
          }
        });
      } catch (_) {}
    }
  };

  const initMeasurementFieldNearAVosMesures = () => {
    const input = findAVosMesuresInput();
    if (!input) return null;
    let wrapper = document.querySelector('.nicha-measurement-field');
    if (wrapper) return wrapper;
    const form = input.form || input.closest('form');
    if (!form) return null;
    const insertPoint = input.closest('fieldset') || input.closest('.product-form__input') || input.closest('variant-radios') || input.closest('label')?.parentElement || input.parentElement;
    if (!insertPoint || !insertPoint.parentNode) return null;
    wrapper = document.createElement('div');
    wrapper.className = 'nicha-measurement-field';
    wrapper.style.display = 'none';
    const textarea = document.createElement('textarea');
    textarea.id = 'nicha-measurements';
    textarea.name = 'properties[Mensurations]';
    textarea.rows = 4;
    textarea.placeholder = isBijouxCollection()
      ? 'Longueur, diamètre souhaité…'
      : 'Tour de taille, tour de poitrine, tour de hanches, longueur souhaitée...';
    if (!form.id) form.id = 'nicha-product-form-' + Date.now();
    textarea.setAttribute('form', form.id);
    const label = document.createElement('label');
    label.setAttribute('for', 'nicha-measurements');
    label.textContent = isBijouxCollection()
      ? 'Votre bijou est fabriqué uniquement pour vous dans notre studio de Chantilly.'
      : 'Votre vêtement-bijou est fabriqué uniquement pour vous dans notre atelier aux portes de Paris. Indiquez toute mesure que vous souhaiteriez personnaliser.';
    wrapper.appendChild(label);
    wrapper.appendChild(textarea);
    insertPoint.parentNode.insertBefore(wrapper, insertPoint.nextSibling);
    const sync = () => {
      const show = input.checked;
      wrapper.style.display = show ? '' : 'none';
      wrapper.hidden = !show;
      if (textarea) {
        textarea.disabled = !show;
        textarea.readOnly = false;
      }
    };
    sync();
    input.addEventListener('change', sync);
    input.addEventListener('click', () => setTimeout(sync, 50));
    const name = input.getAttribute('name');
    if (name) {
      try {
        const root = form || document;
        root.querySelectorAll('input[type="radio"][name="' + CSS.escape(name) + '"]').forEach((r) => {
          r.addEventListener('change', sync);
          r.addEventListener('click', () => setTimeout(sync, 50));
        });
      } catch (_) {}
    }
    return wrapper;
  };

  const updateCustomMeasurementField = () => {
    const directWrapper = initMeasurementFieldNearAVosMesures();
    if (directWrapper) {
      const input = findAVosMesuresInput();
      if (input) {
        directWrapper.style.display = input.checked ? '' : 'none';
        directWrapper.hidden = !input.checked;
      }
      return;
    }
    let context = null;
    const checkedInput = findCheckedSizeInput();
    if (checkedInput) {
      context = {
        form: resolveFormFromInput(checkedInput),
        anchorEl: checkedInput.closest('.product-form__input') || checkedInput.closest('fieldset') || checkedInput.closest('.product-form') || checkedInput.parentElement
      };
    }
    if (!context) context = findSizeContext();
    if (!context) {
      const avosInput = findAVosMesuresInput();
      if (avosInput) {
        const form = avosInput.form || avosInput.closest('form') || document.querySelector('form[action*="/cart/add"]');
        const anchorEl = avosInput.closest('.product-form__input') || avosInput.closest('fieldset') || avosInput.closest('variant-radios') || avosInput.parentElement;
        if (form && anchorEl) context = { form, anchorEl };
      }
    }
    if (!context) {
      const form = document.querySelector('.product-form form, form[action*="/cart/add"]');
      if (form) context = { form, anchorEl: form };
    }
    if (!context || !context.form) {
      cleanupMeasurementFields(null);
      return;
    }
    const currentValueFromDOM = getCurrentSizeValueFromDOM();
    const normalizedCurrent = normalizeText(currentValueFromDOM);
    if (normalizedCurrent) {
      window.NichaLastSizeValue = normalizedCurrent;
    }
    const directCheck = isAVosMesuresRadioChecked();
    const effectiveValue = (normalizedCurrent || window.NichaLastSizeValue || '');
    const shouldShow = directCheck || isCustomSizeValue(effectiveValue);
    const wrapper = ensureCustomMeasurementField(context);
    if (!wrapper) return;
    wrapper.style.display = shouldShow ? '' : 'none';
    wrapper.hidden = !shouldShow;
    wrapper.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    forceTextareaEditable(wrapper);
  };

  const initCustomMeasurementField = () => {
    if (window.NichaCustomMeasurementInitialized) return;
    window.NichaCustomMeasurementInitialized = true;

    const run = () => {
      bindAVosMesuresListeners();
      updateCustomMeasurementField();
    };
    [0, 100, 300, 600, 1000, 1500, 2500, 4000].forEach((delay) => {
      setTimeout(run, delay);
    });
    run();

    const isInSizeFieldset = (el) => {
      const fieldset = findSizeFieldset();
      return fieldset && fieldset.contains && fieldset.contains(el);
    };

    const setLastSizeFromInputOrLabel = (input, labelEl) => {
      if (input && input.matches && input.matches('input[type="radio"]')) {
        if (isInSizeFieldset(input)) {
          const container = input.closest('fieldset') || input.closest('.product-form__input') || input;
          window.NichaLastSizeValue = normalizeText(getSelectedSizeValue(container));
        }
      } else if (labelEl && isInSizeFieldset(labelEl)) {
        window.NichaLastSizeValue = normalizeText(labelEl.textContent || '');
      }
      const v = (window.NichaLastSizeValue || '').toLowerCase();
      window.NichaLastSizeIsCustom =
        v.includes('a vos mesures') || v.includes('vos mesures') || v.includes('made to your measures') || v.includes('your measures');
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches('input[type="radio"], select')) {
        if (target.matches('input[type="radio"]') && isInSizeFieldset(target)) {
          setLastSizeFromInputOrLabel(target, null);
        }
        updateCustomMeasurementField();
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!target) return;
      const label = target.closest ? target.closest('label') : null;
      const labelNorm = label ? normalizeText(label.textContent || '') : '';
      if (label && label.textContent.length < 80 && (labelNorm.includes('vos mesures') || labelNorm.includes('your measures') || labelNorm.includes('made to your measures'))) {
        setTimeout(() => updateCustomMeasurementField(), 10);
      }
      let input = null;
      let labelEl = null;
      if (target.matches && target.matches('input[type="radio"]') && isInSizeFieldset(target)) {
        input = target;
      } else if (label && label.getAttribute('for')) {
        const inputId = label.getAttribute('for');
        input = inputId ? document.getElementById(inputId) : null;
        if (input && isInSizeFieldset(input)) labelEl = label;
      }
      if (input || labelEl) {
        setLastSizeFromInputOrLabel(input, labelEl);
        updateCustomMeasurementField();
      }
    }, true);

    document.addEventListener('input', (event) => {
      if (event.target && event.target.matches('input[type="radio"]') && isInSizeFieldset(event.target)) {
        setLastSizeFromInputOrLabel(event.target, null);
        updateCustomMeasurementField();
      }
    }, true);

    document.addEventListener('variant:change', () => {
      updateCustomMeasurementField();
      setTimeout(() => loadKlarnaScript(() => { initKlarnaPlacement(); injectKlarnaShadowStyles(); }), 100);
    });

    if (document.body && document.body.dataset.nichaMeasurementObserver !== 'true') {
      document.body.dataset.nichaMeasurementObserver = 'true';
      let updateScheduled = null;
      const observer = new MutationObserver(() => {
        if (updateScheduled) return;
        updateScheduled = setTimeout(() => {
          updateScheduled = null;
          bindAVosMesuresListeners();
          updateCustomMeasurementField();
          injectKlarnaStyles();
          loadKlarnaScript(() => { initKlarnaPlacement(); injectKlarnaShadowStyles(); });
        }, 50);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  // ============================================
  // INTERCEPTION AJOUT AU PANIER - PROPRIÉTÉS
  // ============================================

  const initCartAddInterceptor = () => {
    if (window.NichaCartInterceptorActive) return;
    window.NichaCartInterceptorActive = true;
    const origFetch = window.fetch;
    window.fetch = function(url, options) {
      const urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      if (urlStr.includes('/cart/add')) {
        const textarea = document.getElementById('nicha-measurements');
        if (textarea && textarea.value.trim() && !textarea.disabled) {
          const val = textarea.value.trim();
          if (options && options.body instanceof FormData) {
            options.body.set('properties[Mensurations]', val);
          } else if (options && options.body && typeof options.body.append === 'function') {
            options.body.append('properties[Mensurations]', val);
          } else if (options && options.body && typeof options.body === 'string') {
            try {
              const data = JSON.parse(options.body);
              if (!data.properties) data.properties = {};
              data.properties.Mensurations = val;
              options = { ...options, body: JSON.stringify(data) };
            } catch (_) {}
          }
        }
      }
      return origFetch.apply(this, arguments);
    };
  };

  // ============================================
  // AGrandissement des polices sur pages collections
  // ============================================
  
  const injectCollectionFontStyles = () => {
    if (document.getElementById('nicha-collection-fonts-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'nicha-collection-fonts-styles';
    style.textContent = `
      /* Styles pour les titres de produits sur pages collections */
      body.template-collection .card__heading,
      body.template-collection .card__heading a,
      body.template-collection .card__heading h2,
      body.template-collection .card__heading h3,
      body.template-collection .card__information .card__heading,
      body.template-collection .card__information .card__heading a,
      body.template-collection .card-wrapper .card__heading,
      body.template-collection .card-wrapper .card__heading a,
      body[class*="collection"] .card__heading,
      body[class*="collection"] .card__heading a,
      body[class*="collection"] .card__information .card__heading,
      body[class*="collection"] .card__information .card__heading a,
      .collection .card__heading,
      .collection .card__heading a,
      .collection .card__information .card__heading,
      .collection .card__information .card__heading a,
      .grid__item .card__heading,
      .grid__item .card__heading a,
      .grid__item .card__information .card__heading,
      .grid__item .card__information .card__heading a {
        font-size: 1.75rem !important;
        font-weight: normal !important;
        line-height: 1.3 !important;
      }
      
      /* Styles pour les prix sur pages collections */
      body.template-collection .price,
      body.template-collection .price__regular,
      body.template-collection .price-item,
      body.template-collection .price-item--regular,
      body.template-collection .card__information .price,
      body.template-collection .card__information .price__regular,
      body.template-collection .card__information .price-item,
      body.template-collection .card-wrapper .price,
      body.template-collection .card-wrapper .price__regular,
      body[class*="collection"] .price,
      body[class*="collection"] .price__regular,
      body[class*="collection"] .price-item,
      body[class*="collection"] .card__information .price,
      body[class*="collection"] .card__information .price__regular,
      .collection .price,
      .collection .price__regular,
      .collection .price-item,
      .collection .card__information .price,
      .collection .card__information .price__regular,
      .grid__item .price,
      .grid__item .price__regular,
      .grid__item .price-item,
      .grid__item .card__information .price,
      .grid__item .card__information .price__regular {
        font-size: 1.75rem !important;
        font-weight: normal !important;
      }
      
      /* Styles pour les vendors (PRÊT À PARTIR) sur pages collections */
      body.template-collection .card__vendor,
      body.template-collection .card__information .card__vendor,
      body.template-collection .card-wrapper .card__vendor,
      body.template-collection .card__caption .card__vendor,
      body.template-collection [class*="vendor"],
      body.template-collection .card__information [class*="vendor"],
      body[class*="collection"] .card__vendor,
      body[class*="collection"] .card__information .card__vendor,
      body[class*="collection"] [class*="vendor"],
      .collection .card__vendor,
      .collection .card__information .card__vendor,
      .collection [class*="vendor"],
      .grid__item .card__vendor,
      .grid__item .card__information .card__vendor,
      .grid__item [class*="vendor"],
      .card__vendor,
      .card__information .card__vendor,
      [class*="card"][class*="vendor"] {
        font-size: 1.25rem !important;
        font-weight: normal !important;
        letter-spacing: 0.05em !important;
      }
      
      @media (max-width: 768px) {
        body.template-collection .card__heading,
        body.template-collection .card__heading a,
        body.template-collection .card__information .card__heading,
        body[class*="collection"] .card__heading,
        body[class*="collection"] .card__heading a,
        .collection .card__heading,
        .collection .card__heading a,
        .grid__item .card__heading,
        .grid__item .card__heading a {
          font-size: 1.5rem !important;
          font-weight: normal !important;
        }
        
        body.template-collection .price,
        body.template-collection .price__regular,
        body.template-collection .price-item,
        body[class*="collection"] .price,
        body[class*="collection"] .price__regular,
        .collection .price,
        .collection .price__regular,
        .grid__item .price,
        .grid__item .price__regular {
          font-size: 1.5rem !important;
          font-weight: normal !important;
        }
        
        body.template-collection .card__vendor,
        body.template-collection .card__information .card__vendor,
        body.template-collection [class*="vendor"],
        body[class*="collection"] .card__vendor,
        body[class*="collection"] .card__information .card__vendor,
        body[class*="collection"] [class*="vendor"],
        .collection .card__vendor,
        .collection .card__information .card__vendor,
        .collection [class*="vendor"],
        .grid__item .card__vendor,
        .grid__item .card__information .card__vendor,
        .grid__item [class*="vendor"],
        .card__vendor,
        .card__information .card__vendor {
          font-size: 1.125rem !important;
          font-weight: normal !important;
        }
      }
    `;
    document.head.appendChild(style);
  };
  
  const enlargeCollectionFonts = () => {
    const isCollectionPage = document.body.classList.contains('template-collection') ||
                            window.location.pathname.includes('/collections/') ||
                            document.querySelector('.collection') ||
                            document.querySelector('[class*="collection"]');
    
    if (!isCollectionPage) return;
    
    const titleSelectors = [
      '.card__heading',
      '.card__heading a',
      '.card__heading h2',
      '.card__heading h3',
      '.card__information .card__heading',
      '.card__information .card__heading a',
      '.card-information .card__heading',
      '.card-wrapper .card__heading',
      '.grid__item .card__heading',
      '.product-card__title',
      '.product-card .card__heading'
    ];
    
    titleSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.style.fontSize = '1.75rem';
        el.style.fontWeight = 'normal';
        el.style.lineHeight = '1.3';
      });
    });
    
    const priceSelectors = [
      '.card__information .price',
      '.card__information .price__regular',
      '.card__information .price-item',
      '.card__information .price-item--regular',
      '.card-information .price',
      '.card-wrapper .price',
      '.card-wrapper .price__regular',
      '.grid__item .price',
      '.grid__item .price__regular',
      '.grid__item .price-item',
      '.product-card__price',
      '.product-card .price'
    ];
    
    priceSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.style.fontSize = '1.75rem';
        el.style.fontWeight = 'normal';
      });
    });
    
    const vendorSelectors = [
      '.card__vendor',
      '.card__information .card__vendor',
      '.card-information .card__vendor',
      '.card-wrapper .card__vendor',
      '.card__caption .card__vendor',
      '.grid__item .card__vendor',
      '.grid__item .card__information .card__vendor',
      '.product-card__vendor',
      '.product-card .card__vendor',
      '[class*="vendor"]'
    ];
    
    vendorSelectors.forEach(selector => {
      try {
        document.querySelectorAll(selector).forEach(el => {
          const text = (el.textContent || '').trim().toUpperCase();
          const isInCard = el.closest('.card') || el.closest('.grid__item') || el.closest('[class*="card"]');
          
          if (text.includes('PRÊT À PARTIR') || text.includes('PRET A PARTIR') || isInCard) {
            el.style.fontSize = '1.25rem';
            el.style.fontWeight = 'normal';
            el.style.letterSpacing = '0.05em';
          }
        });
      } catch (e) {}
    });
    
    const allElements = document.querySelectorAll('*');
    allElements.forEach(el => {
      const text = (el.textContent || '').trim().toUpperCase();
      if ((text === 'PRÊT À PARTIR' || text === 'PRET A PARTIR') && 
          (el.closest('.card') || el.closest('.grid__item') || el.closest('[class*="collection"]'))) {
        el.style.fontSize = '1.25rem';
        el.style.fontWeight = 'normal';
        el.style.letterSpacing = '0.05em';
      }
    });
    
    if (window.innerWidth <= 768) {
      titleSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.style.fontSize = '1.5rem';
          el.style.fontWeight = 'normal';
        });
      });
      
      priceSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.style.fontSize = '1.5rem';
          el.style.fontWeight = 'normal';
        });
      });
      
      vendorSelectors.forEach(selector => {
        try {
          document.querySelectorAll(selector).forEach(el => {
            const text = (el.textContent || '').trim().toUpperCase();
            const isInCard = el.closest('.card') || el.closest('.grid__item') || el.closest('[class*="card"]');
            
            if (text.includes('PRÊT À PARTIR') || text.includes('PRET A PARTIR') || isInCard) {
              el.style.fontSize = '1.125rem';
              el.style.fontWeight = 'normal';
            }
          });
        } catch (e) {}
      });
      
      const allElementsMobile = document.querySelectorAll('*');
      allElementsMobile.forEach(el => {
        const text = (el.textContent || '').trim().toUpperCase();
        if ((text === 'PRÊT À PARTIR' || text === 'PRET A PARTIR') && 
            (el.closest('.card') || el.closest('.grid__item') || el.closest('[class*="collection"]'))) {
          el.style.fontSize = '1.125rem';
          el.style.fontWeight = 'normal';
        }
      });
    }
  };

  // ============================================
  // Section multicolonnes (lithothérapie) : éviter chevauchement du slider produit
  // ============================================
  const initMulticolumnOverlapFix = () => {
    if (!document.querySelector('.product')) return;
    const mc = document.querySelector('.multicolumn.color-background-1');
    if (mc) {
      if (!mc.dataset.nichaOverlapFixed) {
        mc.dataset.nichaOverlapFixed = '1';
        mc.style.position = 'relative';
        mc.style.zIndex = '5';
        mc.style.marginTop = '5rem';
        mc.style.paddingTop = '2rem';
      }
      if (window.matchMedia('(max-width: 989px)').matches) {
        const pageWidth = mc.querySelector('.page-width');
        if (pageWidth) {
          pageWidth.style.setProperty('padding-left', '1.5rem', 'important');
          pageWidth.style.setProperty('padding-inline-start', '1.5rem', 'important');
        }
      }
      document.body.classList.add('nicha-product-bijoux');
    } else {
      document.body.classList.remove('nicha-product-bijoux');
    }
  };

  // Réduire gap image principale ↔ slider
  const applyProductMediaGapFix = () => {
    if (!document.querySelector('.product')) return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    const set = (el, p, v) => { if (el) el.style.setProperty(p, v, 'important'); };
    const gallery = document.querySelector('media-gallery.product__media-gallery, .product__media-gallery');
    if (gallery) {
      set(gallery, 'display', 'flex');
      set(gallery, 'flex-direction', 'column');
      set(gallery, 'gap', '0.25rem');
      set(gallery, 'row-gap', '0.25rem');
      const searchRoot = gallery.shadowRoot || gallery;
      [].forEach.call(searchRoot.children, (child) => {
        set(child, 'flex', '0 1 auto');
        set(child, 'margin-top', '0');
        set(child, 'margin-bottom', '0');
      });
      if (searchRoot.querySelectorAll) {
        searchRoot.querySelectorAll('.product__media-list, .thumbnail-slider').forEach((el) => {
          set(el, 'flex', '0 1 auto');
          set(el, 'margin-top', '0');
          set(el, 'margin-bottom', '0');
        });
      }
    }
    document.querySelectorAll('.product__media-list, ul.product__media-list').forEach((el) => {
      set(el, 'flex', '0 1 auto');
      set(el, 'margin-bottom', '0');
    });
    document.querySelectorAll('.thumbnail-slider').forEach((el) => {
      set(el, 'margin-top', '0');
      set(el, 'margin-left', '0');
      set(el, 'margin-right', '0');
      set(el, 'max-width', '100%');
      set(el, 'width', '100%');
    });
    document.querySelectorAll('.thumbnail-slider slider-component, .thumbnail-slider.slider-mobile-gutter').forEach((el) => {
      set(el, 'margin-left', '0');
      set(el, 'margin-right', '0');
      set(el, 'max-width', '100%');
      set(el, 'width', '100%');
    });
    const productGrid = document.querySelector('section.page-width[class*="main-padding"] .product.grid, .product.grid');
    if (productGrid) {
      set(productGrid, 'column-gap', 'var(--grid-desktop-horizontal-spacing, 2rem)');
      set(productGrid, 'gap', 'var(--grid-desktop-horizontal-spacing, 2rem)');
    }
  };

  // ESPACE IMAGE ↔ TITRE (mobile) : styles inline pour priorité maximale
  // ============================================
  const applyProductMobileImageTitleSpacing = () => {
    if (!document.querySelector('.product') || !window.matchMedia('(max-width: 989px)').matches) return;
    const mediaEl = document.querySelector('.product__media-wrapper, .product__media-section, .product__media-gallery');
    const infoEl = document.querySelector('.product__info-wrapper, .product__info-section');
    const productEl = document.querySelector('.product, .product__inner, [id*="MainProduct"] .product');
    if (mediaEl) {
      mediaEl.style.marginBottom = '0';
      mediaEl.style.paddingBottom = '0';
    }
    if (infoEl) {
      infoEl.style.marginTop = '0.75rem';
      infoEl.style.paddingTop = '0';
    }
    if (productEl) {
      productEl.style.gap = '0';
      productEl.style.rowGap = '0';
    }
  };

  const initProductMobileImageTitleSpacing = () => {
    if (!document.querySelector('.product') || document.getElementById('nicha-product-mobile-spacing')) return;
    applyProductMobileImageTitleSpacing();
    window.addEventListener('resize', applyProductMobileImageTitleSpacing);
    const style = document.createElement('style');
    style.id = 'nicha-product-mobile-spacing';
    style.textContent = `
      @media (max-width: 989px) {
        :is(body.template-product, body.nicha-product-page) .product,
        :is(body.template-product, body.nicha-product-page) .product .grid,
        :is(body.template-product, body.nicha-product-page) .product__inner,
        :is(body.template-product, body.nicha-product-page) .product__container,
        :is(body.template-product, body.nicha-product-page) [id*="MainProduct"] .grid,
        :is(body.template-product, body.nicha-product-page) [id*="MainProduct"] .product,
        :is(body.template-product, body.nicha-product-page) section[id*="main-product"] .grid,
        :is(body.template-product, body.nicha-product-page) section .product.grid {
          gap: 0 !important;
          row-gap: 0 !important;
          --grid-mobile-vertical-spacing: 0 !important;
        }
        :is(body.template-product, body.nicha-product-page) .grid__item.product__media-wrapper,
        :is(body.template-product, body.nicha-product-page) .product__media-wrapper,
        :is(body.template-product, body.nicha-product-page) .product__media-gallery,
        :is(body.template-product, body.nicha-product-page) media-gallery,
        :is(body.template-product, body.nicha-product-page) .slider-mobile-gutter,
        :is(body.template-product, body.nicha-product-page) slider-component.slider-mobile-gutter,
        :is(body.template-product, body.nicha-product-page) .product__media-list,
        :is(body.template-product, body.nicha-product-page) ul.product__media-list,
        :is(body.template-product, body.nicha-product-page) .product__media-list.grid--peek,
        :is(body.template-product, body.nicha-product-page) .product__media-section {
          margin-bottom: 0 !important;
          padding-bottom: 0 !important;
        }
        :is(body.template-product, body.nicha-product-page) .product__media-list,
        :is(body.template-product, body.nicha-product-page) ul.product__media-list {
          padding-bottom: 0 !important;
        }
        :is(body.template-product, body.nicha-product-page) .grid__item.product__info-wrapper,
        :is(body.template-product, body.nicha-product-page) .product__info-wrapper,
        :is(body.template-product, body.nicha-product-page) .product__info-section {
          margin-top: 0 !important;
          padding-top: 0 !important;
        }
        :is(body.template-product, body.nicha-product-page) .product__info-wrapper {
          margin-top: 0.75rem !important;
        }
        :is(body.template-product, body.nicha-product-page) .product__media-list.grid--peek,
        section.page-width[class*="main-padding"] .product__media-list.grid--peek {
          padding-left: 0 !important;
          padding-inline-start: 0 !important;
          scroll-padding-inline-start: 0 !important;
        }
        :is(body.template-product, body.nicha-product-page) .product__media-item,
        section.page-width[class*="main-padding"] .product__media-item {
          flex: 0 0 100% !important;
          width: 100% !important;
          min-width: 100% !important;
          max-width: 100% !important;
        }
        :is(body.template-product, body.nicha-product-page) .product__media-item .product__media,
        section.page-width[class*="main-padding"] .product__media-item .product__media {
          padding-top: 0 !important;
          aspect-ratio: unset !important;
          height: var(--nicha-product-media-h, auto) !important;
          min-height: var(--nicha-product-media-h, auto) !important;
          max-height: var(--nicha-product-media-h, auto) !important;
          position: relative !important;
          overflow: hidden !important;
        }
        :is(body.template-product, body.nicha-product-page) .product__media-item .product__media img,
        :is(body.template-product, body.nicha-product-page) .product__media-item .product__modal-opener img {
          position: absolute !important;
          inset: 0 !important;
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  // TITRE + PARTAGER : même ligne (mobile) - wrap en flex via JS
  // ============================================
  const initProductTitleShareRow = () => {
    if (!document.querySelector('.product') || !window.matchMedia('(max-width: 989px)').matches) return;
    if (document.getElementById('nicha-title-share-row')) return;
    const container = document.querySelector('.product__info-container');
    const shareBtn = document.querySelector('.share-button');
    const titleEl = document.querySelector('.product__info-container .product__title, .product__info-container h1');
    if (!container || !shareBtn || !titleEl) return;
    const wrapper = document.createElement('div');
    wrapper.id = 'nicha-title-share-row';
    wrapper.style.cssText = 'display:flex!important;align-items:center!important;justify-content:space-between!important;width:100%!important;flex-wrap:wrap!important;gap:.5rem!important;margin-bottom:0!important;';
    container.insertBefore(wrapper, titleEl);
    wrapper.appendChild(titleEl);
    wrapper.appendChild(shareBtn);
    titleEl.style.marginBottom = '0';
  };

  // ESPACE TITRE / PRÊT À PARTIR (mobile uniquement)
  // ============================================

  // ESPACE BLOCS PRODUIT (prix, variantes, globo, klarna, etc.) : styles inline
  // ============================================
  const applyProductInfoBlockSpacing = () => {
    if (!document.querySelector('.product') || !window.matchMedia('(max-width: 989px)').matches) return;
    const container = document.querySelector('.product__info-container');
    const productSection = document.querySelector('.product, [id*="MainProduct"]');
    if (!container) return;
    const setStyle = (el, prop, val, imp) => { if (el) el.style.setProperty(prop, val, imp ? 'important' : ''); };
    setStyle(container, 'display', 'flex', true);
    setStyle(container, 'flex-wrap', 'wrap', true);
    setStyle(container, 'align-items', 'flex-start', true);
    setStyle(container, 'gap', '0.5rem', true);
    [].forEach.call(container.children, (child) => {
      setStyle(child, 'margin-top', '0', true);
      setStyle(child, 'margin-bottom', '0', true);
    });
    container.querySelectorAll('.product__price').forEach(el => setStyle(el, 'margin-bottom', '0', true));
    container.querySelectorAll('.product-form, .product-form__buttons').forEach(el => {
      setStyle(el, 'margin-top', '0', true); setStyle(el, 'margin-bottom', '0', true);
    });
    container.querySelectorAll('.product-form__input').forEach(el => {
      setStyle(el, 'margin-top', '0', true); setStyle(el, 'margin-bottom', '0', true);
    });
    (productSection || document).querySelectorAll('.globo-product-options, [class*="globo"], [data-globo-product-options]').forEach(el => {
      setStyle(el, 'margin-top', '-1rem', true); setStyle(el, 'margin-bottom', '0', true);
    });
    (productSection || document).querySelectorAll('.nicha-klarna-placement-wrapper').forEach(el => {
      setStyle(el, 'margin-top', '-1rem', true); setStyle(el, 'margin-bottom', '1.25rem', true);
    });
    (productSection || document).querySelectorAll('klarna-placement').forEach(el => {
      setStyle(el, 'margin-top', '0', true); setStyle(el, 'margin-bottom', '0', true);
    });
    (productSection || document).querySelectorAll('[class*="trackingmore"], [class*="edd"]').forEach(el => {
      setStyle(el, 'margin-top', '0', true); setStyle(el, 'margin-bottom', '0', true);
    });
    (productSection || document).querySelectorAll('.shopify-block, [class*="shopify-app-block"]').forEach((block) => {
      if (block.querySelector && block.querySelector('[class*="trackingmore"], [class*="edd"]')) {
        setStyle(block, 'margin-bottom', '1.25rem', true);
      }
    });
  };

  const initProductVendorSpacing = () => {
    if (!document.querySelector('.product') || !window.matchMedia('(max-width: 989px)').matches) return;
    let el = document.querySelector('.product__vendor, .product__info-wrapper .product__vendor');
    if (el) {
      el.style.marginTop = '0.75rem';
      return;
    }
    const info = document.querySelector('.product__info-wrapper, [id*="ProductInfo"]');
    if (!info) return;
    for (const node of info.querySelectorAll('p, div, span, h2, h3')) {
      const t = (node.textContent || '').trim().toUpperCase().replace(/\s+/g, ' ');
      if (t === 'PRÊT À PARTIR' || t === 'PRET A PARTIR') {
        node.style.marginTop = '0.75rem';
        break;
      }
    }
  };

  // ============================================
  // VALUE ICONS — Le pouvoir des pierres (Vitals)
  // Injecte le CSS + styles inline (ne dépend pas de custom.css)
  // ============================================

  const VALUE_ICONS_STYLE_ID = 'nicha-value-icons-pierres-css';
  const VALUE_ICONS_MARK = 'data-nicha-pierres-done';
  const PIERRES_TITLES = [
    {
      line1: 'Chaîne amovible',
      line2: 'à porter seule en bague',
      line1En: 'A removable chain',
      line2En: 'designed to transform into a ring',
      test: /cha[iîï]ne|removable chain/i,
    },
    {
      line1: 'Collier amovible',
      line2: 'à porter seul en bracelet',
      line1En: 'A removable necklace',
      line2En: 'designed to transform into a bracelet',
      test: /collier|removable necklace/i,
    },
  ];
  const PIERRES_DESCRIPTIONS = [
    {
      blockTest: /cha[iîï]ne|removable chain/i,
      html:
        '<span class="nicha-pierres-line">La Rhyolite apaise l\u2019esprit, éloigne les doutes</span><span class="nicha-pierres-line">et invite à avancer avec confiance.</span><span class="nicha-pierres-line">Idéale pour les Taureaux, Lions et Vierges.</span>',
      htmlEn:
        '<span class="nicha-pierres-line">Rhyolite soothes the mind, quiets self-doubt,</span><span class="nicha-pierres-line">and inspires confidence in every step forward.</span><span class="nicha-pierres-line">Ideal for Taurus, Leo, and Virgo.</span>',
    },
    {
      blockTest: /collier|removable necklace/i,
      html:
        '<span class="nicha-pierres-line">L\u2019Améthyste stimule la créativité,</span><span class="nicha-pierres-line">nourrit l\u2019imagination et favorise la clarté d\u2019esprit.</span><span class="nicha-pierres-line">Idéale pour les Sagittaires, Verseaux et Capricornes.</span>',
      htmlEn:
        '<span class="nicha-pierres-line">Amethyst inspires creativity,</span><span class="nicha-pierres-line">fuels the imagination, and encourages clarity of mind.</span><span class="nicha-pierres-line">Ideal for Sagittarius, Aquarius, and Capricorn.</span>',
    },
  ];
  const VALUE_ICONS_SECTION_ID = 'shopify-section-template--30374607421772__tsapb_ce7789ea_8wFhFr';
  const VALUE_ICONS_DESKTOP_GAP_PX = 240;
  const VALUE_ICONS_SPACER_CLASS = 'nicha-pierres-spacer';
  const LIFESTYLE_IMG_CHAIN_HANDLES = ['veste-avalon', 'avalon-blazer'];
  const LIFESTYLE_IMG_COLLIER_HANDLES = ['haut-bells', 'bells-top'];

  const isEnglishLocale = () => {
    const locale = (window.Shopify?.locale || document.documentElement.lang || 'fr').toLowerCase();
    return locale === 'en' || locale.startsWith('en-');
  };

  const pierresTextIsChain = (text) => /cha[iîï]ne|removable chain/i.test(text || '');
  const pierresTextIsCollier = (text) => /collier|removable necklace/i.test(text || '');

  const findPierresBlockChain = (blocks) =>
    blocks.find((block) => pierresTextIsChain(block.textContent || ''));

  const findPierresBlockCollier = (blocks) =>
    blocks.find((block) => pierresTextIsCollier(block.textContent || ''));

  const findLifestyleImageByHandles = (images, handles) => {
    for (const handle of handles) {
      const found = images.find((item) =>
        item.querySelector(`a[href*="/products/${handle}"]`)
      );
      if (found) return found;
    }
    return null;
  };

  const galleryHasLifestyleProducts = (gallery) =>
    LIFESTYLE_IMG_CHAIN_HANDLES.some((h) =>
      gallery.querySelector(`a[href*="/products/${h}"]`)
    ) &&
    LIFESTYLE_IMG_COLLIER_HANDLES.some((h) =>
      gallery.querySelector(`a[href*="/products/${h}"]`)
    );

  const PIERRES_INNER_RESET_SELECTORS = [
    'vtls-media-gallery',
    '.VtlsMediaGalleryContainer',
    '.VtlsMediaGalleryGrid',
    '.VtlsMediaGalleryImages',
    'section.VtlsValueIcons',
    '.VtlsValueIcons',
    '.VtlsValueIconsContainer',
    '.VtlsValueIconsList',
    'slideshow-component',
    '.slideshow',
    '.banner',
    '.slider-component',
    '.slideshow__slide',
    '.slideshow__media',
    '.banner__media',
    '.media',
    '.deferred-media',
  ];

  const isNichaHomepage = () => {
    if (document.body.classList.contains('template-index')) return true;
    if (document.documentElement.classList.contains('template-index')) return true;
    if (document.body.classList.contains('nicha-homepage')) return true;
    const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path === '' || path === '/') return true;
    return /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path);
  };

  const ensureHomepageBodyClass = () => {
    if (!isNichaHomepage()) return;
    document.body.classList.add('nicha-homepage');
    document.documentElement.classList.add('nicha-homepage');
  };

  const isHomepageHeaderDesktopViewport = () =>
    window.matchMedia('(min-width: 990px)').matches;

  const HOMEPAGE_HEADER_SEARCH_MARK = 'data-nicha-header-search-home';
  let homepageHeaderSearchPlacement = null;

  const rememberHomepageHeaderSearchPlacement = (node) => {
    if (!node || homepageHeaderSearchPlacement) return;
    homepageHeaderSearchPlacement = {
      parent: node.parentNode,
      next: node.nextSibling,
    };
  };

  const restoreHomepageHeaderSearch = () => {
    const moved = document.querySelector(`[${HOMEPAGE_HEADER_SEARCH_MARK}="1"]`);
    if (!moved || !homepageHeaderSearchPlacement?.parent?.isConnected) return;
    const { parent, next } = homepageHeaderSearchPlacement;
    if (next && next.parentNode === parent) {
      parent.insertBefore(moved, next);
    } else {
      parent.appendChild(moved);
    }
    moved.removeAttribute(HOMEPAGE_HEADER_SEARCH_MARK);
  };

  const findHeaderLanguageWidget = (icons) =>
    icons?.querySelector(
      '.embed-etranslate-LanguageList, .language-button, #etranslate-language-button, [class*="etranslate-language"]'
    );

  const relocateHomepageHeaderSearch = () => {
    if (!isHomepageHeaderDesktopViewport()) {
      restoreHomepageHeaderSearch();
      return;
    }

    const header = document.querySelector('.header.header--has-menu.header--top-center');
    const icons = header?.querySelector('.header__icons');
    if (!header || !icons) return;

    const outsideSearch = header.querySelector(':scope > .header__search');
    const iconsSearch = icons.querySelector('.header__search');
    let search = outsideSearch || iconsSearch;
    if (!search) return;

    if (!icons.contains(search)) {
      rememberHomepageHeaderSearchPlacement(search);
    }

    search.setAttribute(HOMEPAGE_HEADER_SEARCH_MARK, '1');
    search.style.removeProperty('display');

    const account = icons.querySelector('.header__icon--account');
    if (account) {
      icons.insertBefore(search, account);
    } else {
      const lang = findHeaderLanguageWidget(icons);
      if (lang?.nextSibling) {
        icons.insertBefore(search, lang.nextSibling);
      } else if (lang) {
        lang.after(search);
      } else if (!icons.contains(search)) {
        icons.prepend(search);
      }
    }

    [...icons.querySelectorAll('.header__search')].forEach((node) => {
      if (node !== search) node.remove();
    });
  };

  const initHomepageHeaderDesktopLayout = () => {
    relocateHomepageHeaderSearch();
  };

  window.NichaHomepageHeaderLayout = initHomepageHeaderDesktopLayout;

  const NICHA_HEADER_DESKTOP_STYLE_ID = 'nicha-homepage-header-desktop-css';

  const getNichaHeaderDesktopCssText = () => `
@media (min-width:990px){
.header.header--top-center.page-width.header--has-menu{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:baseline!important;justify-content:flex-start!important;column-gap:clamp(2.25rem,4.5vw,4rem)!important;row-gap:0!important;grid-template-columns:unset!important;grid-template-areas:unset!important;padding-top:1rem!important;padding-bottom:1rem!important}
.header.header--top-center.header--has-menu>.header__search{display:none!important}
.header.header--top-center.header--has-menu .header__heading{position:static!important;inset:auto!important;transform:none!important;justify-self:auto!important;text-align:left!important;margin:0!important;padding:0!important;flex:0 0 auto!important;order:1!important;align-self:baseline!important}
.header.header--top-center.header--has-menu .header__heading-link{display:inline-flex!important;justify-content:flex-start!important;align-items:flex-end!important;line-height:0!important;margin:0!important}
.header.header--top-center.header--has-menu .header__heading-logo,.header.header--top-center.header--has-menu .header__heading-link .h2{width:auto!important;max-width:none!important;max-height:clamp(3rem,4.75vw,3.875rem)!important;height:auto!important;object-fit:contain!important;display:block!important}
.header.header--top-center.header--has-menu .header__inline-menu{position:static!important;inset:auto!important;transform:none!important;justify-self:auto!important;align-self:baseline!important;margin:0!important;margin-top:0!important;margin-left:0!important;padding:0!important;flex:1 1 auto!important;min-width:0!important;order:2!important}
.header.header--top-center.header--has-menu .header__inline-menu .list-menu--inline{justify-content:flex-start!important;align-items:baseline!important;gap:clamp(.75rem,1.8vw,1.75rem)!important}
.header .header__inline-menu .list-menu--inline>li>a.header__menu-item,.header .header__inline-menu .list-menu--inline>li>details-disclosure summary.header__menu-item,.header .header__inline-menu .list-menu--inline>li>details>summary.header__menu-item{margin:0!important;padding:0!important;font-size:1.125rem!important;font-weight:400!important;letter-spacing:.015em!important;line-height:1.15!important}
.header .header__inline-menu .list-menu--inline>li>details-disclosure summary.header__menu-item,.header .header__inline-menu .list-menu--inline>li>details>summary.header__menu-item{display:inline-flex!important;align-items:center!important;gap:.35rem!important}
.header .header__inline-menu .list-menu--inline>li>details-disclosure summary.header__menu-item .icon-caret,.header .header__inline-menu .list-menu--inline>li>details>summary.header__menu-item .icon-caret{position:static!important;inset:auto!important;right:auto!important;top:auto!important;flex-shrink:0!important;margin-left:.25rem!important;height:.6rem!important;width:.625rem!important}
.header .header__inline-menu .list-menu--inline>li>a.header__menu-item span,.header .header__inline-menu .list-menu--inline>li>details-disclosure summary.header__menu-item span,.header .header__inline-menu .list-menu--inline>li>details>summary.header__menu-item span{font-size:inherit!important}
.header .header__submenu.list-menu--disclosure{padding:1rem 0!important;min-width:17rem!important}
.header .header__submenu.list-menu--disclosure>li{margin:0!important;padding:0!important;width:100%!important}
.header .header__submenu.list-menu--disclosure>li+li{margin-top:.2rem!important}
.header .header__submenu .list-menu__item{margin:0!important}
.header .header__submenu.list-menu--disclosure>li>a.header__menu-item,.header .header__submenu.list-menu--disclosure>li>details>summary.header__menu-item{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:1.5rem!important;width:100%!important;box-sizing:border-box!important;font-size:1.0625rem!important;font-weight:400!important;letter-spacing:.01em!important;line-height:1.5!important;padding:.9rem 2.4rem!important;margin:0!important;min-height:2.75rem!important}
.header .header__submenu.list-menu--disclosure>li>details{width:100%!important}
.header .header__submenu.list-menu--disclosure>li>details>summary.header__menu-item span,.header .header__submenu.list-menu--disclosure>li>a.header__menu-item{flex:1 1 auto!important;min-width:0!important;text-align:left!important}
.header .header__submenu.list-menu--disclosure>li>details>summary.header__menu-item .icon-caret{position:static!important;inset:auto!important;right:auto!important;top:auto!important;flex:0 0 auto!important;margin-left:.75rem!important;height:.6rem!important;width:.625rem!important}
.header .header__submenu .header__menu-item,.header .header__submenu .list-menu__item .link,.header .header__submenu .list-menu__item .header__menu-item,.header .header__submenu .header__menu-item.caption-large{font-size:1.0625rem!important;font-weight:400!important;letter-spacing:.01em!important;line-height:1.5!important;padding:.9rem 2.4rem!important}
.header .header__submenu .header__submenu{padding:.35rem 0!important;margin:0!important;background-color:transparent!important}
.header .header__submenu .header__submenu .header__menu-item{padding:.75rem 2.4rem .75rem 3rem!important;min-height:2.5rem!important}
.header .mega-menu__link{font-size:1.0625rem!important;line-height:1.55!important;padding-top:.65rem!important;padding-bottom:.65rem!important}
.header.header--top-center.header--has-menu .header__icons{display:flex!important;flex-direction:row!important;align-items:center!important;align-self:center!important;justify-content:flex-end!important;flex:0 0 auto!important;margin-left:auto!important;gap:.25rem!important;order:3!important}
.header.header--top-center.header--has-menu .header__icons .header__search{display:inline-flex!important;align-items:center!important;order:2!important;margin:0!important}
.header.header--top-center.header--has-menu .header__icons .embed-etranslate-LanguageList,.header.header--top-center.header--has-menu .header__icons .language-button,.header.header--top-center.header--has-menu .header__icons .transcy-switcher-manual:not(.hidden){order:1!important}
.header.header--top-center.header--has-menu .header__icons .header__icon--account{order:3!important}
.header.header--top-center.header--has-menu .header__icons .header__icon--cart{order:4!important}
.header.header--top-center.header--has-menu .header__icons .transcy-switcher-manual.hidden{display:none!important}
}`;

  const injectHomepageHeaderDesktopStyles = () => {
    let style = document.getElementById(NICHA_HEADER_DESKTOP_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = NICHA_HEADER_DESKTOP_STYLE_ID;
      document.head.appendChild(style);
    }
    style.textContent = getNichaHeaderDesktopCssText();

    const script = document.querySelector('script[src*="custom-nicha.js"]');
    const href = script?.src
      ? script.src.replace(/custom-nicha\.js(\?.*)?$/, 'nicha-homepage-header-desktop.css')
      : '';
    const linkId = `${NICHA_HEADER_DESKTOP_STYLE_ID}-link`;
    if (href && !document.getElementById(linkId)) {
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }
  };

  window.NichaHomepageHeaderStyles = injectHomepageHeaderDesktopStyles;

  const injectHomepageDesktopFontStyles = () => {
    if (!isNichaHomepage()) return;
    let style = document.getElementById('nicha-homepage-desktop-fonts');
    if (!style) {
      style = document.createElement('style');
      style.id = 'nicha-homepage-desktop-fonts';
      document.head.appendChild(style);
    }
    /* Titres = taille thème d’origine (plus de 90 % sur #MainContent qui les réduisait) */
    style.textContent = '';
  };

  const NICHA_HOME_SLIDESHOW_STYLE_ID = 'nicha-homepage-slideshow-mobile-css';
  const NICHA_SLIDESHOW_IMG_MARK = 'data-nicha-slideshow-crop';
  const NICHA_SLIDESHOW_IMG_SEL =
    '#MainContent slideshow-component .slideshow__media img, #MainContent slideshow-component .slideshow__slide img, #MainContent slideshow-component .banner__media img';
  const NICHA_SLIDESHOW_MEDIA_SEL =
    '#MainContent slideshow-component .slideshow__media, #MainContent slideshow-component .banner__media';

  const isHomepageSlideshowMobileViewport = () =>
    window.matchMedia('(max-width: 989px)').matches;

  const applyHomepageSlideshowMobileCrop = () => {
    if (!isNichaHomepage()) return;
    const imgs = document.querySelectorAll(NICHA_SLIDESHOW_IMG_SEL);
    if (!isHomepageSlideshowMobileViewport()) {
      imgs.forEach((img) => {
        if (!img.hasAttribute(NICHA_SLIDESHOW_IMG_MARK)) return;
        [
          'position',
          'top',
          'left',
          'right',
          'bottom',
          'inset',
          'width',
          'height',
          'max-width',
          'object-fit',
          'object-position',
          'transform',
          'transform-origin',
        ].forEach((prop) => img.style.removeProperty(prop));
        img.removeAttribute(NICHA_SLIDESHOW_IMG_MARK);
      });
      return;
    }
    document.querySelectorAll(NICHA_SLIDESHOW_MEDIA_SEL).forEach((media) => {
      media.style.setProperty('position', 'relative', 'important');
      media.style.setProperty('overflow', 'hidden', 'important');
      media.style.setProperty('padding-bottom', '0', 'important');
    });
    imgs.forEach((img) => {
      img.setAttribute(NICHA_SLIDESHOW_IMG_MARK, '1');
      img.style.setProperty('position', 'absolute', 'important');
      img.style.setProperty('top', '0', 'important');
      img.style.setProperty('left', '0', 'important');
      img.style.setProperty('right', 'auto', 'important');
      img.style.setProperty('bottom', 'auto', 'important');
      img.style.setProperty('width', 'auto', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('min-height', '100%', 'important');
      img.style.setProperty('max-width', 'none', 'important');
      img.style.setProperty('object-fit', 'unset', 'important');
      img.style.setProperty('object-position', 'left center', 'important');
      img.style.setProperty('transform', 'none', 'important');
    });
  };

  const injectHomepageSlideshowMobileStyles = () => {
    if (!isNichaHomepage()) return;
    let style = document.getElementById(NICHA_HOME_SLIDESHOW_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = NICHA_HOME_SLIDESHOW_STYLE_ID;
      document.head.appendChild(style);
    }
    style.textContent = `
      @media (max-width: 989px) {
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__slide {
          display: flex !important;
          flex-direction: column !important;
          height: auto !important;
          min-height: 0 !important;
          overflow: visible !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__media,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__media.media,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__media.media {
          position: relative !important;
          flex: 0 0 58vh !important;
          height: 58vh !important;
          min-height: 58vh !important;
          padding-bottom: 0 !important;
          overflow: hidden !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__media.media::before,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__media.media::before {
          display: none !important;
          content: none !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__media img,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__slide img,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__media img,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__media picture img {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: auto !important;
          bottom: auto !important;
          width: auto !important;
          height: 100% !important;
          min-height: 100% !important;
          max-width: none !important;
          object-fit: unset !important;
          object-position: left center !important;
          transform: none !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__text-wrapper,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__content {
          position: relative !important;
          width: 100% !important;
          padding: 0 1.5rem 0 !important;
          text-align: center !important;
          align-items: center !important;
          justify-content: center !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__text,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__box {
          text-align: center !important;
          align-items: center !important;
          margin: 0 auto !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__heading {
          text-align: center !important;
          margin: 2.25rem auto 0 !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__text {
          text-align: center !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__buttons {
          margin: 2rem auto 1.5rem !important;
        }
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .banner__buttons .button,
        :is(body.template-index, body.nicha-homepage) #MainContent slideshow-component .slideshow__text .button {
          margin-bottom: 1.25rem !important;
        }
      }
    `;
  };

  const VALUE_ICONS_PIERRES_CSS = `
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsContainer,
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsList {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock {
  gap: 0.35rem !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__TextContent {
  gap: 0.15rem !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Heading {
  margin: 0 0 0.85rem !important;
  padding: 0 !important;
}
@media (min-width: 992px) {
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons.nicha-pierres-aligned .VtlsValueIconsContainer {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons.nicha-pierres-aligned .VtlsValueIconsList {
    position: relative !important;
    display: block !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin-right: auto !important;
    min-height: 1px !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons.nicha-pierres-aligned .VtlsValueIconsBlock {
    position: absolute !important;
    top: 0 !important;
    width: auto !important;
    max-width: min(420px, 100%) !important;
    flex: none !important;
    margin: 0 !important;
    transform: translateX(-50%) !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons.nicha-pierres-aligned .nicha-pierres-spacer {
    display: none !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons:not(.nicha-pierres-aligned) .VtlsValueIconsList {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: center !important;
    align-items: flex-start !important;
    width: 100% !important;
    max-width: none !important;
    padding: 0 !important;
    margin: 0 auto !important;
    gap: 0 !important;
    column-gap: 0 !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons:not(.nicha-pierres-aligned) .VtlsValueIconsBlock {
    flex: 0 1 380px !important;
    width: auto !important;
    max-width: 400px !important;
    min-width: 0 !important;
  }
  #${VALUE_ICONS_SECTION_ID} .nicha-pierres-spacer {
    flex: 0 0 ${VALUE_ICONS_DESKTOP_GAP_PX}px !important;
    width: ${VALUE_ICONS_DESKTOP_GAP_PX}px !important;
    min-width: ${VALUE_ICONS_DESKTOP_GAP_PX}px !important;
    max-width: ${VALUE_ICONS_DESKTOP_GAP_PX}px !important;
    padding: 0 !important;
    margin: 0 !important;
    border: 0 !important;
    list-style: none !important;
    visibility: hidden !important;
    pointer-events: none !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__IconWrapper {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    gap: 0.5rem !important;
    margin-bottom: 0.15rem !important;
  }
}
@media (max-width: 991px) {
  #${VALUE_ICONS_SECTION_ID}.nicha-pierres-icons,
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: clip !important;
    box-sizing: border-box !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsContainer,
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsList {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
  }
  #${VALUE_ICONS_SECTION_ID} .nicha-pierres-spacer {
    display: none !important;
    flex: 0 0 0 !important;
    width: 0 !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsList {
    display: flex !important;
    flex-direction: column !important;
    row-gap: 3rem !important;
    gap: 3rem !important;
  }
  #${VALUE_ICONS_SECTION_ID}.nicha-pierres-mobile-stacked .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsList {
    display: none !important;
  }
  .nicha-pierres-mobile-stack {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 1.25rem !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
    list-style: none !important;
  }
  .nicha-pierres-mobile-stack > .nicha-pierres-mobile-img-block,
  .nicha-pierres-mobile-stack > .nicha-pierres-mobile-row {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    list-style: none !important;
  }
  .nicha-pierres-mobile-stack > .shopify-section,
  .nicha-pierres-mobile-stack > vtls-media-gallery {
    width: 100% !important;
    max-width: 100% !important;
  }
  .nicha-pierres-mobile-stack > .VtlsValueIconsBlock,
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock,
  .nicha-pierres-mobile-stack .VtlsMediaGalleryImage {
    list-style: none !important;
    list-style-type: none !important;
  }
  .nicha-pierres-mobile-stack > .VtlsValueIconsBlock::marker,
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock::marker,
  .nicha-pierres-mobile-stack .VtlsMediaGalleryImage::marker {
    content: none !important;
    display: none !important;
  }
  .nicha-pierres-mobile-img-block__track {
    display: block !important;
    width: 100% !important;
  }
  .nicha-pierres-mobile-stack .nicha-pierres-mobile-img-item,
  .nicha-pierres-mobile-stack .nicha-pierres-mobile-img-block .VtlsMediaGalleryImage {
    position: relative !important;
    left: 0 !important;
    top: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .nicha-pierres-mobile-stack .VtlsMediaGalleryImage__Wrapper,
  .nicha-pierres-mobile-stack .VtlsMediaGalleryImage__Wrapper a {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .nicha-pierres-mobile-stack .VtlsMediaGalleryImage__Image,
  .nicha-pierres-mobile-stack .nicha-pierres-mobile-img-block img {
    width: 100% !important;
    height: auto !important;
    max-width: 100% !important;
    max-height: none !important;
    object-fit: cover !important;
    display: block !important;
  }
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto !important;
    padding: 0 0.75rem !important;
    box-sizing: border-box !important;
    text-align: center !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__TextContent,
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__Heading,
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__Description {
    text-align: center !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__IconWrapper {
    justify-content: center !important;
    margin-bottom: 0.35rem !important;
    width: 100% !important;
  }
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__Icon,
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__Icon img {
    width: auto !important;
    max-width: 100px !important;
    max-height: 100px !important;
    height: auto !important;
    margin: 0 auto !important;
  }
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__Heading {
    font-size: clamp(0.95rem, 4vw, 1.05rem) !important;
    margin-bottom: 0.85rem !important;
  }
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__Description {
    font-size: clamp(0.78rem, 3.2vw, 0.88rem) !important;
    line-height: 1.3 !important;
  }
  .nicha-pierres-mobile-stack .nicha-pierres-desc--3lines,
  .nicha-pierres-mobile-stack .nicha-pierres-desc--preset,
  .nicha-pierres-mobile-stack .nicha-pierres-block--collier .VtlsValueIconsBlock__Description,
  .nicha-pierres-mobile-stack .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description {
    display: block !important;
    line-height: 1.4 !important;
    margin-top: 0.9rem !important;
    max-width: calc(100vw - 2rem) !important;
    width: max-content !important;
    margin-left: auto !important;
    margin-right: auto !important;
    overflow: visible !important;
  }
  .nicha-pierres-mobile-stack .VtlsValueIconsBlock__Description.nicha-pierres-lines .nicha-pierres-line,
  .nicha-pierres-mobile-stack .nicha-pierres-block--collier .VtlsValueIconsBlock__Description .nicha-pierres-line,
  .nicha-pierres-mobile-stack .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description .nicha-pierres-line {
    display: block !important;
    white-space: nowrap !important;
    line-height: 1.4 !important;
  }
  /* Espace supplémentaire : Chaîne amovible → image lifestyle du dessous */
  .nicha-pierres-mobile-stack > .VtlsValueIconsBlock + .nicha-pierres-mobile-img-block {
    margin-top: 2rem !important;
  }
  .nicha-pierres-mobile-row__track {
    display: flex !important;
    flex-direction: row !important;
    align-items: stretch !important;
    gap: 0.75rem !important;
    width: 100% !important;
  }
  .nicha-pierres-mobile-row .VtlsMediaGalleryImage {
    position: relative !important;
    left: 0 !important;
    top: auto !important;
    flex: 1 1 0 !important;
    min-width: 0 !important;
    width: auto !important;
    height: auto !important;
  }
}
@media (min-width: 992px) {
  #nicha-pierres-mobile-stack {
    display: none !important;
  }
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Heading {
  line-height: 1.2 !important;
  width: max-content !important;
  max-width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center !important;
  overflow: visible !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Heading .nicha-title-line--sub,
.VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Heading .nicha-title-line--sub {
  display: block !important;
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
  hyphens: manual !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Description {
  display: block !important;
  overflow: visible !important;
  text-overflow: clip !important;
  -webkit-line-clamp: unset !important;
  line-clamp: unset !important;
  max-height: none !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0.9rem 0 0 !important;
  padding: 0 !important;
  line-height: 1.38 !important;
  text-align: center !important;
  box-sizing: border-box !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-desc--preset,
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-desc--3lines {
  line-height: 1.4 !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Description.nicha-pierres-lines br {
  display: block !important;
  content: '' !important;
  margin: 0 !important;
  line-height: 1.4 !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Description.nicha-pierres-lines .nicha-pierres-line,
.VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Description.nicha-pierres-lines .nicha-pierres-line {
  display: block !important;
  line-height: 1.4 !important;
  white-space: nowrap !important;
}
@media (max-width: 991px) {
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--collier .VtlsValueIconsBlock__Description.nicha-pierres-lines,
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description.nicha-pierres-lines,
  .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--collier .VtlsValueIconsBlock__Description.nicha-pierres-lines,
  .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description.nicha-pierres-lines {
    font-size: clamp(0.72rem, 2.75vw, 0.82rem) !important;
    max-width: calc(100vw - 2rem) !important;
    width: max-content !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
@media (min-width: 992px) {
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description,
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--collier .VtlsValueIconsBlock__Description,
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons .VtlsValueIconsBlock__Description.nicha-pierres-lines,
  .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--collier .VtlsValueIconsBlock__Description.nicha-pierres-lines,
  .VtlsValueIcons.nicha-pierres-icons .nicha-pierres-block--chaine .VtlsValueIconsBlock__Description.nicha-pierres-lines {
    display: block !important;
    min-width: 22rem !important;
    max-width: 32rem !important;
    white-space: normal !important;
  }
}`;

  const injectValueIconsPierresStyles = () => {
    let el = document.getElementById(VALUE_ICONS_STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = VALUE_ICONS_STYLE_ID;
      document.head.appendChild(el);
    }
    el.textContent = VALUE_ICONS_PIERRES_CSS;
    document.head.appendChild(el);
  };

  const ensurePierresListSpacer = (list, mobile) => {
    if (!list) return;
    const blocks = [...list.querySelectorAll(':scope > .VtlsValueIconsBlock')];
    let spacer = list.querySelector(`:scope > .${VALUE_ICONS_SPACER_CLASS}`);
    if (mobile || blocks.length < 2) {
      if (spacer) spacer.style.setProperty('display', 'none', 'important');
      return;
    }
    if (!spacer) {
      spacer = document.createElement('li');
      spacer.className = VALUE_ICONS_SPACER_CLASS;
      spacer.setAttribute('aria-hidden', 'true');
      list.insertBefore(spacer, blocks[1]);
    }
    spacer.style.setProperty('display', 'block', 'important');
    spacer.style.setProperty('flex', `0 0 ${VALUE_ICONS_DESKTOP_GAP_PX}px`, 'important');
    spacer.style.setProperty('width', `${VALUE_ICONS_DESKTOP_GAP_PX}px`, 'important');
    spacer.style.setProperty('min-width', `${VALUE_ICONS_DESKTOP_GAP_PX}px`, 'important');
    spacer.style.setProperty('max-width', `${VALUE_ICONS_DESKTOP_GAP_PX}px`, 'important');
    spacer.style.setProperty('padding', '0', 'important');
    spacer.style.setProperty('margin', '0', 'important');
    spacer.style.setProperty('border', '0', 'important');
    spacer.style.setProperty('list-style', 'none', 'important');
    spacer.style.setProperty('visibility', 'hidden', 'important');
    spacer.style.setProperty('pointer-events', 'none', 'important');
  };

  const findValueIconsPierresRoot = () => {
    const byContent = [...document.querySelectorAll('#MainContent .VtlsValueIcons, .VtlsValueIcons')].find(
      (el) =>
        pierresTextIsChain(el.textContent || '') &&
        pierresTextIsCollier(el.textContent || '')
    );
    if (byContent) return byContent;
    return document.getElementById(VALUE_ICONS_SECTION_ID)?.querySelector('.VtlsValueIcons') || null;
  };

  const valueIconsKeepLineIntact = (text) => text.replace(/ /g, '\u00a0');

  const pierresTitleHtml = (preset) =>
    `${preset.line1}<br aria-hidden="true"><span class="nicha-title-line nicha-title-line--sub">${preset.line2.replace(/ a bracelet\b/i, '\u00a0a\u00a0bracelet').replace(/ a ring\b/i, '\u00a0a\u00a0ring')}</span>`;

  const pierresTitleIsCorrect = (heading, preset) => {
    if (!heading || !preset) return false;
    const sub = heading.querySelector('.nicha-title-line--sub');
    if (!sub) return false;
    const line1 = (heading.childNodes[0]?.textContent || heading.textContent || '')
      .split('\n')[0]
      .replace(/\u00a0/g, ' ')
      .trim();
    const line2 = sub.textContent.replace(/\u00a0/g, ' ').trim();
    return line1 === preset.line1 && line2 === preset.line2;
  };

  const applyPierresTitle = (heading, preset) => {
    if (!heading || !preset) return;
    const effective = {
      line1: isEnglishLocale() && preset.line1En ? preset.line1En : preset.line1,
      line2: isEnglishLocale() && preset.line2En ? preset.line2En : preset.line2,
    };
    if (pierresTitleIsCorrect(heading, effective)) return;
    heading.innerHTML = pierresTitleHtml(effective);
    heading.dataset.nichaTitleSplit = 'v3';
  };

  const forceAllPierresTitles = (root) => {
    const headings = [...root.querySelectorAll('.VtlsValueIconsBlock__Heading')];
    if (headings.length >= 2) {
      applyPierresTitle(headings[0], PIERRES_TITLES[0]);
      applyPierresTitle(headings[1], PIERRES_TITLES[1]);
      return;
    }
    headings.forEach((heading) => {
      const preset = PIERRES_TITLES.find((t) => t.test.test(heading.textContent || ''));
      if (preset) applyPierresTitle(heading, preset);
    });
  };

  const watchPierresHeadings = (root) => {
    if (!root || typeof MutationObserver === 'undefined') return;
    const headings = root.querySelectorAll('.VtlsValueIconsBlock__Heading');
    headings.forEach((heading, index) => {
      if (heading.dataset.nichaHeadingWatch === '1') return;
      heading.dataset.nichaHeadingWatch = '1';
      const preset = PIERRES_TITLES[index] || PIERRES_TITLES.find((t) => t.test.test(heading.textContent || ''));
      if (!preset) return;
      const mo = new MutationObserver(() => {
        if (!pierresTitleIsCorrect(heading, preset)) {
          applyPierresTitle(heading, preset);
        }
      });
      mo.observe(heading, { childList: true, characterData: true, subtree: true });
    });
  };

  const getPierresDescriptionPreset = (block) => {
    if (!block) return null;
    const headingText = block.querySelector('.VtlsValueIconsBlock__Heading')?.textContent || '';
    return PIERRES_DESCRIPTIONS.find((d) => d.blockTest.test(headingText)) || null;
  };

  const formatPierresDescription = (paragraph) => {
    if (!paragraph) return;

    const block = paragraph.closest('.VtlsValueIconsBlock');
    const preset = getPierresDescriptionPreset(block);
    const headingText = block?.querySelector('.VtlsValueIconsBlock__Heading')?.textContent || '';
    const isCollier = pierresTextIsCollier(headingText);
    const isChaine = pierresTextIsChain(headingText);

    paragraph.classList.remove('nicha-pierres-desc--3lines', 'nicha-pierres-desc--preset');
    block?.classList.remove('nicha-pierres-block--collier', 'nicha-pierres-block--chaine');

    if (preset) {
      if (isCollier) {
        paragraph.classList.add('nicha-pierres-desc--3lines');
        block?.classList.add('nicha-pierres-block--collier');
      }
      if (isChaine) {
        paragraph.classList.add('nicha-pierres-desc--3lines');
        block?.classList.add('nicha-pierres-block--chaine');
      }
      paragraph.classList.add('nicha-pierres-desc--preset', 'nicha-pierres-lines');
      paragraph.innerHTML =
        isEnglishLocale() && preset.htmlEn ? preset.htmlEn : preset.html;
      paragraph.dataset.nichaPierresDescFormatted = 'v16';
      return;
    }

    const raw = paragraph.textContent.replace(/\s+/g, ' ').trim();
    if (!raw) return;

    let html = raw;
    if (/\bet invite\b/i.test(raw)) {
      html = html.replace(/\s+(et invite\b)/i, '<br>$1');
    }
    if (/\sand inspires\b/i.test(raw)) {
      html = html.replace(/\s+(and inspires\b)/i, '<br>$1');
    }
    if (/\sand encourages\b/i.test(raw)) {
      html = html.replace(/\s+(and encourages\b)/i, '<br>$1');
    }
    if (/\sIdéale\b/i.test(raw) || /\sIdeale\b/i.test(raw)) {
      html = html.replace(/([.!?])\s+(Idéale\b)/i, '$1<br>$2');
    }
    if (/\sIdeal for\b/i.test(raw)) {
      html = html.replace(/([.!?])\s+(Ideal for\b)/i, '$1<br>$2');
    }

    if (paragraph.innerHTML !== html) paragraph.innerHTML = html;
    paragraph.dataset.nichaPierresDescFormatted = 'true';
  };

  const resetPierresMobileLayout = (root) => {
    if (!root) return;
    root.classList.remove('nicha-pierres-aligned');
    const list = root.querySelector('.VtlsValueIconsList');
    const container = root.querySelector('.VtlsValueIconsContainer');
    [list, container].forEach((el) => {
      if (!el) return;
      [
        'position',
        'width',
        'max-width',
        'min-height',
        'margin-left',
        'margin-right',
        'display',
        'flex-flow',
        'justify-content',
        'gap',
        'column-gap',
        'padding-left',
        'padding-right',
      ].forEach((prop) => el.style.removeProperty(prop));
    });
    root.querySelectorAll('.VtlsValueIconsBlock').forEach((block) => {
      [
        'position',
        'left',
        'top',
        'transform',
        'max-width',
        'flex',
        'width',
        'grid-column',
        'justify-self',
        'margin',
      ].forEach((prop) => block.style.removeProperty(prop));
    });
    if (list) ensurePierresListSpacer(list, true);
  };

  const applyValueIconsPierresInline = (root) => {
    const list = root.querySelector('.VtlsValueIconsList');
    const mobile = window.matchMedia('(max-width: 991px)').matches;
    if (mobile) {
      resetPierresMobileLayout(root);
    }
    const alignedDesktop = !mobile && root.classList.contains('nicha-pierres-aligned');
    ensurePierresListSpacer(list, mobile);
    if (list) {
      list.style.setProperty('padding-left', '0', 'important');
      list.style.setProperty('padding-right', '0', 'important');
      if (mobile) {
        list.style.removeProperty('grid-template-columns');
        list.style.removeProperty('column-gap');
        list.style.removeProperty('margin-left');
        list.style.setProperty('flex-direction', 'column', 'important');
        list.style.setProperty('row-gap', '3rem', 'important');
        list.style.setProperty('gap', '3rem', 'important');
      } else if (!alignedDesktop) {
        list.style.setProperty('display', 'flex', 'important');
        list.style.setProperty('flex-direction', 'row', 'important');
        list.style.setProperty('flex-wrap', 'nowrap', 'important');
        list.style.setProperty('justify-content', 'center', 'important');
        list.style.setProperty('align-items', 'flex-start', 'important');
        list.style.setProperty('width', '100%', 'important');
        list.style.setProperty('max-width', 'none', 'important');
        list.style.setProperty('gap', '0', 'important');
        list.style.setProperty('column-gap', '0', 'important');
      }
    }
    const container = root.querySelector('.VtlsValueIconsContainer');
    if (container) {
      container.style.setProperty('padding-left', '0', 'important');
      container.style.setProperty('padding-right', '0', 'important');
    }
    root.querySelectorAll('.VtlsValueIconsBlock').forEach((block) => {
      block.style.setProperty('margin-left', '0', 'important');
      block.style.setProperty('margin-right', '0', 'important');
      block.style.setProperty('gap', '0.35rem', 'important');
      if (!mobile && !alignedDesktop) {
        block.style.setProperty('flex', '0 1 380px', 'important');
        block.style.setProperty('width', 'auto', 'important');
        block.style.setProperty('max-width', '400px', 'important');
      }
    });
    root.querySelectorAll('.VtlsValueIconsBlock__TextContent').forEach((tc) => {
      tc.style.setProperty('gap', '0.15rem', 'important');
      tc.style.setProperty('padding', '0', 'important');
      tc.style.setProperty('margin', '0', 'important');
      tc.style.setProperty('width', '100%', 'important');
      tc.style.setProperty('max-width', '100%', 'important');
    });
    root.querySelectorAll('.VtlsValueIconsBlock__Description').forEach((p) => {
      p.style.setProperty('display', 'block', 'important');
      p.style.setProperty('overflow', 'visible', 'important');
      p.style.setProperty('max-height', 'none', 'important');
      p.style.setProperty('max-width', '100%', 'important');
      p.style.setProperty('width', '100%', 'important');
      p.style.setProperty('margin', '0.9rem 0 0', 'important');
      p.style.setProperty('padding', '0', 'important');
      p.style.setProperty('line-height', '1.32', 'important');
      p.style.removeProperty('-webkit-line-clamp');
      p.style.removeProperty('-webkit-box-orient');
    });
    if (!mobile) {
      root.querySelectorAll('.VtlsValueIconsBlock__IconWrapper').forEach((wrap) => {
        wrap.style.setProperty('display', 'flex', 'important');
        wrap.style.setProperty('flex-direction', 'row', 'important');
        wrap.style.setProperty('margin-bottom', '0.15rem', 'important');
      });
    }
    forceAllPierresTitles(root);
    root.querySelectorAll('.VtlsValueIconsBlock__Description').forEach(formatPierresDescription);
  };

  const initValueIconsPierresContent = (root) => {
    if (!root) return;
    root.classList.add('nicha-pierres-icons');
    const wrap = root.closest('.shopify-section');
    if (wrap) wrap.classList.add('nicha-pierres-icons');
    root.setAttribute(VALUE_ICONS_MARK, '1');
    forceAllPierresTitles(root);
    watchPierresHeadings(root);
    root.querySelectorAll('.VtlsValueIconsBlock__Description').forEach(formatPierresDescription);
  };

  const initValueIconsPierres = () => {
    if (!isNichaHomepage()) return;
    injectValueIconsPierresStyles();
    const root = findValueIconsPierresRoot();
    if (!root) return;
    initValueIconsPierresContent(root);
    applyValueIconsPierresInline(root);

    if (window.matchMedia('(max-width: 991px)').matches) {
      initPierresMobileStack();
      return;
    }

    restorePierresMobileStack();
    alignValueIconsUnderGallery();
  };

  window.NichaFixPierresTitles = () => {
    const root = findValueIconsPierresRoot();
    if (root) {
      forceAllPierresTitles(root);
      watchPierresHeadings(root);
      alignValueIconsUnderGallery();
    }
    return root;
  };

  // ============================================
  // MEDIA GALLERY — 2 images lifestyle (Vitals kufxj7)
  // Layout absolu : on force un gap plus large entre les 2 colonnes
  // ============================================

  const LIFESTYLE_GALLERY_SEL = 'vtls-media-gallery[class*="eebdb509_kufxj7"]';
  const PRIMARY_GALLERY_SEL = 'vtls-media-gallery[class*="eebdb509_vfiwkf"]';
  const LIFESTYLE_GALLERY_GAP_DESKTOP = 200;
  const LIFESTYLE_GALLERY_STYLE_ID = 'nicha-lifestyle-gallery-fit-css';

  const LIFESTYLE_GALLERY_FIT_CSS = `
${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow-x: visible !important;
}
${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap .VtlsMediaGalleryContainer,
${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap .VtlsMediaGalleryGrid {
  box-sizing: border-box !important;
  overflow: visible !important;
}
${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap .VtlsMediaGalleryImages {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  box-sizing: border-box !important;
}
#${VALUE_ICONS_SECTION_ID}.nicha-pierres-icons {
  max-width: 100% !important;
  overflow-x: clip !important;
  box-sizing: border-box !important;
}
#${VALUE_ICONS_SECTION_ID} .VtlsValueIcons.nicha-pierres-icons.nicha-pierres-aligned .VtlsValueIconsContainer {
  max-width: 100% !important;
  overflow-x: clip !important;
}
@media (min-width: 992px) {
  ${LIFESTYLE_GALLERY_SEL} {
    --section-width: 100% !important;
    --section-max-width: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
  ${LIFESTYLE_GALLERY_SEL} .VtlsMediaGalleryContainer,
  #${VALUE_ICONS_SECTION_ID} .VtlsValueIconsContainer {
    width: var(--nicha-pierres-track-width, 100%) !important;
    max-width: var(--nicha-pierres-track-width, 100%) !important;
    margin-left: var(--nicha-pierres-track-offset, 0) !important;
    margin-right: auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    box-sizing: border-box !important;
  }
}
@media (max-width: 991px) {
  ${LIFESTYLE_GALLERY_SEL} {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: clip !important;
    box-sizing: border-box !important;
  }
  ${LIFESTYLE_GALLERY_SEL} .VtlsMediaGalleryContainer,
  ${LIFESTYLE_GALLERY_SEL} .VtlsMediaGalleryGrid,
  ${LIFESTYLE_GALLERY_SEL} .VtlsMediaGalleryImages {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    overflow-x: clip !important;
    box-sizing: border-box !important;
  }
  ${LIFESTYLE_GALLERY_SEL} .VtlsMediaGalleryImages {
    position: relative !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  ${LIFESTYLE_GALLERY_SEL} .VtlsMediaGalleryImage {
    position: relative !important;
    left: 0 !important;
    top: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin-left: 0 !important;
  }
  ${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap .VtlsMediaGalleryImage {
    left: 0 !important;
    top: auto !important;
  }
}
@media (min-width: 992px) {
  ${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap .VtlsMediaGalleryImage__Wrapper,
  ${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap a.VtlsMediaGalleryImage__Wrapper {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }
  ${LIFESTYLE_GALLERY_SEL}.nicha-lifestyle-gallery--wide-gap .VtlsMediaGalleryImage__Image {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
}`;

  const injectLifestyleGalleryFitStyles = () => {
    let el = document.getElementById(LIFESTYLE_GALLERY_STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = LIFESTYLE_GALLERY_STYLE_ID;
      document.head.appendChild(el);
    }
    el.textContent = LIFESTYLE_GALLERY_FIT_CSS;
    document.head.appendChild(el);
  };

  const findPrimaryProductGallery = () => {
    if (window.NichaSquareMediaGallery?.getPrimaryGallery) {
      const fromApi = window.NichaSquareMediaGallery.getPrimaryGallery();
      if (fromApi) return fromApi;
    }
    return (
      document.querySelector(PRIMARY_GALLERY_SEL) ||
      document.querySelector('vtls-media-gallery.nicha-gallery--primary') ||
      document.querySelector('vtls-media-gallery[data-nicha-primary-gallery="true"]')
    );
  };

  const LIFESTYLE_SECTION_SEL =
    '[id*="eebdb509_KUFXj7"], [id*="eebdb509_kufxj7"]';
  const findLifestyleMediaGallery = () =>
    document.querySelector(LIFESTYLE_GALLERY_SEL) ||
    document.querySelector(`${LIFESTYLE_SECTION_SEL} vtls-media-gallery`) ||
    [...document.querySelectorAll('vtls-media-gallery')].find(galleryHasLifestyleProducts) ||
    null;

  const findPierresBannerSection = () => {
    const byId = document.querySelector(
      '.shopify-section[id*="slideshow_hdyEyY"], .shopify-section[id*="slideshow_hdyeyy"]'
    );
    if (byId) return byId;
    const matches = [...document.querySelectorAll('.shopify-section')].filter((sec) =>
      /pouvoir des pierres/i.test(sec.textContent || '')
    );
    if (matches.length > 1) return matches[matches.length - 1];
    return matches[0] || null;
  };

  /** Mesure la piste réelle : bord gauche 1re tuile → bord droit dernière tuile */
  const measurePrimaryPierresTrack = () => {
    const primary = findPrimaryProductGallery();
    if (!primary) return null;

    const first = primary.querySelector('.VtlsMediaGalleryImage:first-child');
    const last = primary.querySelector('.VtlsMediaGalleryImage:last-child');
    const list = primary.querySelector('.VtlsMediaGalleryImages');
    const container = primary.querySelector('.VtlsMediaGalleryContainer');
    const sec = primary.closest('.shopify-section');
    const secRect = sec?.getBoundingClientRect();

    if (first && last) {
      const fr = first.getBoundingClientRect();
      const lr = last.getBoundingClientRect();
      const width = lr.right - fr.left;
      if (width > 200) {
        return {
          left: fr.left,
          right: lr.right,
          width,
          offset: Math.max(0, Math.round(fr.left - (secRect?.left ?? 0))),
          sectionLeft: secRect?.left ?? 0,
          sectionWidth: secRect?.width ?? width,
          el: list || container,
        };
      }
    }

    const refEl = list || container;
    if (!refEl) return null;
    const rect = refEl.getBoundingClientRect();
    const lastRect = last?.getBoundingClientRect();
    if (rect.width < 200) return null;
    return {
      left: rect.left,
      right: lastRect?.right ?? rect.right,
      width: lastRect ? lastRect.right - rect.left : rect.width,
      offset: Math.max(0, Math.round(rect.left - (secRect?.left ?? 0))),
      sectionLeft: secRect?.left ?? 0,
      sectionWidth: secRect?.width ?? rect.width,
      el: refEl,
    };
  };

  const copyVitalsGalleryVarsFromPrimary = (targetGallery) => {
    const primary = findPrimaryProductGallery();
    if (!primary || !targetGallery) return;
    ['--section-width', '--section-max-width'].forEach((name) => {
      let val = getComputedStyle(primary).getPropertyValue(name).trim();
      if (!val || val === 'px') val = '100%';
      targetGallery.style.setProperty(name, val);
    });
  };

  const syncPierresBlockToPrimaryTrack = (blockEl, track) => {
    if (!blockEl || !track) return;
    const hostSection = blockEl.closest('.shopify-section') || blockEl;
    const secRect = hostSection.getBoundingClientRect();
    const width = Math.round(track.width);
    const offset = Math.max(0, Math.round(track.left - secRect.left));
    blockEl.style.setProperty('width', `${width}px`, 'important');
    blockEl.style.setProperty('max-width', `${width}px`, 'important');
    blockEl.style.setProperty('margin-left', `${offset}px`, 'important');
    blockEl.style.setProperty('margin-right', 'auto', 'important');
    blockEl.style.setProperty('padding-left', '0', 'important');
    blockEl.style.setProperty('padding-right', '0', 'important');
    blockEl.style.setProperty('box-sizing', 'border-box', 'important');
  };

  const getPrimaryPierresSectionLayout = () => {
    const primary = findPrimaryProductGallery();
    const primarySec = primary?.closest('.shopify-section');
    if (!primarySec) return null;
    const secRect = primarySec.getBoundingClientRect();
    if (secRect.width < 200) return null;
    const track = measurePrimaryPierresTrack();
    return {
      sectionWidth: secRect.width,
      sectionLeft: secRect.left,
      trackWidth: track?.width ?? secRect.width,
      trackLeft: track?.left ?? secRect.left,
      trackOffset: track?.offset ?? 0,
      primarySec,
    };
  };

  const forcePierresSectionInnerFullWidth = (sectionEl) => {
    if (!sectionEl || !isPierresDesktopViewport()) return;
    PIERRES_INNER_RESET_SELECTORS.forEach((sel) => {
      sectionEl.querySelectorAll(sel).forEach((el) => {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('margin-left', '0', 'important');
        el.style.setProperty('margin-right', '0', 'important');
        el.style.setProperty('padding-left', '0', 'important');
        el.style.setProperty('padding-right', '0', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
        if (el.matches('vtls-media-gallery')) {
          el.style.setProperty('--section-width', '100%', 'important');
          el.style.setProperty('--section-max-width', '100%', 'important');
        }
      });
    });
  };

  const syncPierresInnerContainersToTrack = (track) => {
    if (!track || !isPierresDesktopViewport()) return;
    const lifestyle = findLifestyleMediaGallery();
    if (lifestyle) {
      copyVitalsGalleryVarsFromPrimary(lifestyle);
      syncPierresBlockToPrimaryTrack(
        lifestyle.querySelector('.VtlsMediaGalleryContainer'),
        track
      );
    }
    syncPierresBlockToPrimaryTrack(
      document.getElementById(VALUE_ICONS_SECTION_ID)?.querySelector('.VtlsValueIconsContainer'),
      track
    );
  };

  const syncPierresRestSection = (sectionEl, layout) => {
    if (!sectionEl || !layout?.primarySec || sectionEl === layout.primarySec) return;
    if (!isPierresDesktopViewport()) return;
    sectionEl.classList.add('nicha-pierres-rest-section');
  };

  const syncPierresBannerToTrack = (layout) => {
    const bannerSec = findPierresBannerSection();
    if (!bannerSec || !layout) return;
    syncPierresRestSection(bannerSec, layout);
  };

  const PIERRES_INLINE_PROPS = [
    'width',
    'max-width',
    'min-width',
    'margin-left',
    'margin-right',
    'padding-left',
    'padding-right',
    'overflow-x',
    'box-sizing',
    '--section-width',
    '--section-max-width',
    '--page-width',
  ];

  const clearPierresSectionInlineStyles = (sectionEl) => {
    if (!sectionEl) return;
    PIERRES_INLINE_PROPS.forEach((prop) => sectionEl.style.removeProperty(prop));
    PIERRES_INNER_RESET_SELECTORS.forEach((sel) => {
      sectionEl.querySelectorAll(sel).forEach((el) => {
        PIERRES_INLINE_PROPS.forEach((prop) => el.style.removeProperty(prop));
      });
    });
  };

  const getPierresRestSections = () =>
    [
      findLifestyleMediaGallery()?.closest('.shopify-section'),
      document.getElementById(VALUE_ICONS_SECTION_ID),
      findPierresBannerSection(),
    ].filter(Boolean);

  const isPierresDesktopViewport = () =>
    window.matchMedia('(min-width: 992px)').matches;

  const clearLifestyleGalleryDesktopLayout = (gallery) => {
    if (!gallery) return;
    [...gallery.querySelectorAll('.VtlsMediaGalleryImage')].forEach((item) => {
      ['width', 'height', 'left', 'top'].forEach((prop) => item.style.removeProperty(prop));
    });
    const list = gallery.querySelector('.VtlsMediaGalleryImages');
    if (list) {
      ['width', 'height', 'max-width', 'margin-left', 'margin-right'].forEach((prop) =>
        list.style.removeProperty(prop)
      );
    }
    const container = gallery.querySelector('.VtlsMediaGalleryContainer');
    if (container) {
      ['width', 'max-width', 'margin-left', 'margin-right', 'padding-left', 'padding-right'].forEach(
        (prop) => container.style.removeProperty(prop)
      );
    }
    gallery.classList.remove('nicha-lifestyle-gallery--wide-gap');
    delete gallery.dataset.nichaLifestyleBaseTileW;
    delete gallery.dataset.nichaLifestyleBaseTileH;
    delete gallery.dataset.nichaLifestyleGap;
    delete gallery.dataset.nichaLifestyleScale;
    delete gallery.dataset.nichaLifestyleTileW;
  };

  const pierresDesktopWasApplied = () =>
    !!document.documentElement.style.getPropertyValue('--nicha-pierres-track-width').trim() ||
    !!document.querySelector('.nicha-pierres-rest-section') ||
    !!findLifestyleMediaGallery()?.classList.contains('nicha-lifestyle-gallery--wide-gap') ||
    !!findValueIconsPierresRoot()?.classList.contains('nicha-pierres-aligned');

  const clearPierresDesktopLayout = () => {
    if (!pierresDesktopWasApplied()) return;

    document.documentElement.style.removeProperty('--nicha-pierres-track-width');
    document.documentElement.style.removeProperty('--nicha-pierres-track-offset');
    document.documentElement.style.removeProperty('--nicha-pierres-section-width');

    clearLifestyleGalleryDesktopLayout(findLifestyleMediaGallery());

    const root = findValueIconsPierresRoot();
    if (root) resetPierresMobileLayout(root);

    getPierresRestSections().forEach((sec) => {
      sec.classList.remove('nicha-pierres-rest-section');
      clearPierresSectionInlineStyles(sec);
    });

    document.querySelectorAll('.nicha-pierres-rest-section').forEach((sec) => {
      sec.classList.remove('nicha-pierres-rest-section');
      clearPierresSectionInlineStyles(sec);
    });
  };

  const clearPierresUnifiedLayout = () => {
    clearPierresDesktopLayout();
  };

  const syncPierresDesktopTrackOnly = () => {
    if (!window.matchMedia('(min-width: 992px)').matches) return null;
    const track = measurePrimaryPierresTrack();
    if (!track) return null;

    document.documentElement.style.setProperty(
      '--nicha-pierres-track-width',
      `${Math.round(track.width)}px`
    );
    document.documentElement.style.setProperty(
      '--nicha-pierres-track-offset',
      `${track.offset}px`
    );

    const lifestyle = findLifestyleMediaGallery();
    if (lifestyle) {
      copyVitalsGalleryVarsFromPrimary(lifestyle);
      syncPierresBlockToPrimaryTrack(
        lifestyle.querySelector('.VtlsMediaGalleryContainer'),
        track
      );
    }

    syncPierresBlockToPrimaryTrack(
      document.getElementById(VALUE_ICONS_SECTION_ID)?.querySelector('.VtlsValueIconsContainer'),
      track
    );

    return track;
  };

  const applyPierresUnifiedLayout = () => syncPierresDesktopTrackOnly();

  const applyDesktopPierresLayout = () => {
    if (!isNichaHomepage()) {
      clearPierresDesktopLayout();
      return;
    }
    if (!window.matchMedia('(min-width: 992px)').matches) return;
    restorePierresMobileStack();
    syncPierresDesktopTrackOnly();
    const gallery = findLifestyleMediaGallery();
    if (gallery) applyLifestyleMediaGalleryGap(gallery);
    const root = findValueIconsPierresRoot();
    if (root) {
      applyValueIconsPierresInline(root);
      alignValueIconsUnderGallery();
    }
  };

  window.NichaPierresLayoutDebug = () => ({
    track: measurePrimaryPierresTrack(),
    section: getPrimaryPierresSectionLayout(),
    cssTrack: getComputedStyle(document.documentElement).getPropertyValue('--nicha-pierres-track-width'),
    cssSection: getComputedStyle(document.documentElement).getPropertyValue('--nicha-pierres-section-width'),
    lifestyle: !!findLifestyleMediaGallery(),
    lifestyleContainerW: findLifestyleMediaGallery()?.querySelector('.VtlsMediaGalleryContainer')?.clientWidth,
    wideGap: findLifestyleMediaGallery()?.classList.contains('nicha-lifestyle-gallery--wide-gap'),
    valueIcons: !!document.getElementById(VALUE_ICONS_SECTION_ID),
    valueContainerW: document.getElementById(VALUE_ICONS_SECTION_ID)?.querySelector('.VtlsValueIconsContainer')?.clientWidth,
    banner: !!findPierresBannerSection(),
    restSections: document.querySelectorAll('.nicha-pierres-rest-section').length,
    mobileStack: !!document.getElementById(PIERRES_MOBILE_STACK_ID)?.children?.length,
    mobileActive: document.body.classList.contains('nicha-pierres-mobile-active'),
    version: window.NICHA_CUSTOM_VERSION,
    primary: !!findPrimaryProductGallery(),
  });

  window.NichaPierresUnifiedLayout = applyPierresUnifiedLayout;
  window.NichaPierresLayoutPipeline = applyDesktopPierresLayout;
  window.NichaPierresClearDesktop = clearPierresDesktopLayout;

  /** Même conteneur Vitals que la 1re galerie produits (VfiWkF) */
  const getPierresLayoutReference = (gallery) => {
    const layout = getPrimaryPierresSectionLayout();
    const track = measurePrimaryPierresTrack();
    if (layout) {
      const left = track?.left ?? layout.sectionLeft;
      const width = track?.width ?? layout.sectionWidth;
      return {
        left,
        right: left + width,
        width,
        el: track?.el,
      };
    }
    const galSec = gallery?.closest('.shopify-section');
    if (galSec) {
      const r = galSec.getBoundingClientRect();
      if (r.width > 200) {
        return { left: r.left, right: r.right, width: r.width, el: galSec };
      }
    }
    const w = document.documentElement.clientWidth;
    return { left: 0, right: w, width: w, el: null };
  };

  const syncLifestyleGalleryContainerWithPrimary = (gallery) => {
    const lContainer = gallery?.querySelector('.VtlsMediaGalleryContainer');
    if (!lContainer) return null;
    const track = measurePrimaryPierresTrack();
    copyVitalsGalleryVarsFromPrimary(gallery);
    if (track) {
      syncPierresBlockToPrimaryTrack(lContainer, track);
    } else {
      lContainer.style.setProperty('width', '100%', 'important');
      lContainer.style.setProperty('max-width', '100%', 'important');
      lContainer.style.setProperty('margin-left', '0', 'important');
      lContainer.style.setProperty('margin-right', '0', 'important');
    }
    lContainer.style.setProperty('padding-left', '0', 'important');
    lContainer.style.setProperty('padding-right', '0', 'important');
    const layout = getPrimaryPierresSectionLayout();
    return {
      width: lContainer.clientWidth || Math.round(track?.width ?? layout?.sectionWidth ?? 0),
      left: track?.left ?? layout?.sectionLeft ?? 0,
      offset: track?.offset ?? 0,
    };
  };

  const getLifestyleGalleryMaxWidth = (gallery) => {
    const lContainer = gallery?.querySelector('.VtlsMediaGalleryContainer');
    const list = gallery?.querySelector('.VtlsMediaGalleryImages');
    const measured =
      (list?.clientWidth > 200 && list.clientWidth) ||
      (lContainer?.clientWidth > 200 && lContainer.clientWidth);
    if (measured) return Math.round(measured);

    const track = measurePrimaryPierresTrack();
    if (track?.width > 200) return Math.round(track.width);

    const layout = getPrimaryPierresSectionLayout();
    if (layout?.sectionWidth > 200) {
      return Math.round(layout.sectionWidth);
    }
    const ref = getPierresLayoutReference(gallery);
    return Math.round(ref.width || gallery.closest('.shopify-section')?.clientWidth || 0);
  };

  const getLifestyleGalleryTrackOffset = (gallery) => {
    const lContainer = gallery?.querySelector('.VtlsMediaGalleryContainer');
    if (lContainer) {
      const ml = parseFloat(getComputedStyle(lContainer).marginLeft);
      if (!Number.isNaN(ml) && ml >= 0) return Math.round(ml);
    }
    const galSec = gallery?.closest('.shopify-section');
    const ref = getPierresLayoutReference(gallery);
    const galSecRect = galSec?.getBoundingClientRect();
    if (!galSecRect) return 0;
    return Math.max(0, Math.round(ref.left - galSecRect.left));
  };

  const resetLifestyleMediaGallery = (gallery, { clearBase = true } = {}) => {
    if (!gallery) return;
    [...gallery.querySelectorAll('.VtlsMediaGalleryImage')].forEach((item) => {
      ['width', 'height', 'left', 'top'].forEach((prop) => item.style.removeProperty(prop));
    });
    const list = gallery.querySelector('.VtlsMediaGalleryImages');
    if (list) {
      ['width', 'height', 'max-width', 'margin-left', 'margin-right'].forEach((prop) =>
        list.style.removeProperty(prop)
      );
    }
    const container = gallery.querySelector('.VtlsMediaGalleryContainer');
    if (container) {
      ['width', 'max-width', 'margin-left', 'margin-right', 'padding-left', 'padding-right'].forEach(
        (prop) => container.style.removeProperty(prop)
      );
    }
    gallery.classList.remove('nicha-lifestyle-gallery--wide-gap');
    if (clearBase) {
      delete gallery.dataset.nichaLifestyleBaseTileW;
      delete gallery.dataset.nichaLifestyleBaseTileH;
      delete gallery.dataset.nichaLifestyleGap;
      delete gallery.dataset.nichaLifestyleScale;
      delete gallery.dataset.nichaLifestyleTileW;
    }
  };

  const getLifestyleGalleryBaseTile = (gallery, first, list, cols) => {
    if (gallery.dataset.nichaLifestyleBaseTileW) {
      return {
        w: parseFloat(gallery.dataset.nichaLifestyleBaseTileW),
        h: parseFloat(gallery.dataset.nichaLifestyleBaseTileH),
      };
    }
    const vitalsGap = Number(gallery.getAttribute('data-gap')) || 40;
    let w =
      parseFloat(first.style.width) ||
      first.getBoundingClientRect().width ||
      first.offsetWidth;
    const listW =
      list && (parseFloat(list.style.width) || list.getBoundingClientRect().width);
    if (listW > 0 && cols >= 2) {
      const inferred = (listW - vitalsGap * (cols - 1)) / cols;
      if (inferred > 0 && (!w || Math.abs(w - inferred) < 120)) w = inferred;
    }
    let h =
      parseFloat(first.style.height) ||
      first.getBoundingClientRect().height ||
      first.offsetHeight;
    if (!h || h < 40) h = w;
    gallery.dataset.nichaLifestyleBaseTileW = String(Math.round(w));
    gallery.dataset.nichaLifestyleBaseTileH = String(Math.round(h));
    return { w, h };
  };

  const getPrimaryGalleryTileMetrics = () => {
    const primary = findPrimaryProductGallery();
    const first = primary?.querySelector('.VtlsMediaGalleryImage');
    if (!first) return null;

    const fromDataset = parseFloat(primary.dataset.nichaUniformBaseH);
    const h =
      (fromDataset > 40 && fromDataset) ||
      parseFloat(first.style.height) ||
      first.getBoundingClientRect().height;
    const w =
      parseFloat(primary.dataset.nichaUniformBaseW) ||
      parseFloat(first.style.width) ||
      first.getBoundingClientRect().width;

    if (!h || h < 40) return null;
    return { w: Math.round(w || h), h: Math.round(h) };
  };

  const fitLifestyleGalleryDimensions = (gallery, baseW, baseH, targetGap, cols) => {
    const maxW = getLifestyleGalleryMaxWidth(gallery);
    const primaryTile = getPrimaryGalleryTileMetrics();
    const targetHeight = Math.max(baseH, primaryTile?.h || 0);
    const aspect = baseW > 0 && baseH > 0 ? baseW / baseH : 1;

    if (!maxW) {
      const tileHeight = targetHeight;
      const tileWidth = tileHeight * aspect;
      return {
        tileWidth,
        tileHeight,
        gap: targetGap,
        scale: baseH > 0 ? tileHeight / baseH : 1,
        totalWidth: cols * tileWidth + Math.max(0, cols - 1) * targetGap,
        maxW: 0,
      };
    }

    let gap = targetGap;
    let tileWidth = (maxW - Math.max(0, cols - 1) * gap) / cols;
    if (tileWidth < 80 && cols >= 2) {
      gap = Math.max(Number(gallery.getAttribute('data-gap')) || 40, Math.round(maxW * 0.08));
      tileWidth = (maxW - Math.max(0, cols - 1) * gap) / cols;
    }

    const tileHeight = targetHeight;
    const scale = baseH > 0 ? tileHeight / baseH : 1;
    const totalWidth = cols * tileWidth + Math.max(0, cols - 1) * gap;

    return {
      tileWidth,
      tileHeight,
      gap,
      scale,
      totalWidth,
      maxW,
    };
  };

  const getLifestyleGalleryLayout = (gallery, images) => {
    const track = gallery.querySelector('.VtlsMediaGalleryImages');
    const mobile = window.matchMedia('(max-width: 991px)').matches;
    const gap = mobile
      ? Number(gallery.getAttribute('data-gap')) || 40
      : Number(gallery.dataset.nichaLifestyleGap) || LIFESTYLE_GALLERY_GAP_DESKTOP;
    const first = images[0];
    const tileWidth =
      parseFloat(first.style.width) ||
      first.getBoundingClientRect().width ||
      first.offsetWidth;
    const trackRect = track?.getBoundingClientRect();
    const trackLeft = trackRect?.left ?? first.getBoundingClientRect().left;
    const totalWidth =
      trackRect?.width ||
      images.length * tileWidth + Math.max(0, images.length - 1) * gap;

    const visualCenterX = (item) => {
      const visual = item.querySelector(
        'img.VtlsMediaGalleryImage__Image, img, a.VtlsMediaGalleryImage__Wrapper, a'
      );
      const rect = (visual || item).getBoundingClientRect();
      return rect.left + rect.width / 2;
    };

    const slots = images.map((item, index) => {
      const layoutCenter = trackLeft + index * (tileWidth + gap) + tileWidth / 2;
      const visualCenter = visualCenterX(item);
      const centerX =
        index > 0 ? Math.max(layoutCenter, visualCenter) : layoutCenter;
      return {
        item,
        index,
        centerX,
        tileWidth,
      };
    });

    return { track, trackLeft, totalWidth, gap, tileWidth, slots };
  };

  const findPierresBlock = (blocks, pattern) =>
    blocks.find((block) => pattern.test(block.textContent || ''));

  /** Aligne chaque Value Icon sous le centre de l’image correspondante au-dessus */
  const alignValueIconsUnderGallery = () => {
    const mobile = window.matchMedia('(max-width: 991px)').matches;
    const gallery = findLifestyleMediaGallery();
    const root = findValueIconsPierresRoot();
    const list = root?.querySelector('.VtlsValueIconsList');
    if (!root || !list) return;

    const blocks = [...list.querySelectorAll(':scope > .VtlsValueIconsBlock')];

    if (mobile) {
      resetPierresMobileLayout(root);
      initPierresMobileStack();
      return;
    }

    restorePierresMobileStack();
    syncPierresDesktopTrackOnly();

    const images = [...gallery?.querySelectorAll('.VtlsMediaGalleryImage') || []];
    if (!gallery || images.length < 2 || blocks.length < 2) {
      root.classList.remove('nicha-pierres-aligned');
      ensurePierresListSpacer(list, false);
      return;
    }

    const spacer = list.querySelector(`:scope > .${VALUE_ICONS_SPACER_CLASS}`);
    if (spacer) spacer.style.setProperty('display', 'none', 'important');

    const blockLeft = findPierresBlockChain(blocks) || blocks[0];
    const blockRight = findPierresBlockCollier(blocks) || blocks[1];
    const imgLeft =
      findLifestyleImageByHandles(images, LIFESTYLE_IMG_CHAIN_HANDLES) || images[0];
    const imgRight =
      findLifestyleImageByHandles(images, LIFESTYLE_IMG_COLLIER_HANDLES) || images[1];

    const applyAligned = () => {
      const layout = getLifestyleGalleryLayout(gallery, images);
      const slotLeft = layout.slots.find((s) => s.item === imgLeft) || layout.slots[0];
      const slotRight = layout.slots.find((s) => s.item === imgRight) || layout.slots[1];
      const ref = getPierresLayoutReference(gallery);
      const maxW = getLifestyleGalleryMaxWidth(gallery);
      const valueSection = root.closest('.shopify-section');
      const sectionRect = valueSection?.getBoundingClientRect();
      const lContainer = gallery.querySelector('.VtlsMediaGalleryContainer');
      const trackRect = layout.track?.getBoundingClientRect();
      const containerRect = lContainer?.getBoundingClientRect();
      const trackLeft = Math.round(containerRect?.left ?? trackRect?.left ?? ref.left);
      const sectionLeft = Math.round(sectionRect?.left ?? 0);
      const offsetInSection = Math.max(0, trackLeft - sectionLeft);
      const listWidth = Math.max(
        1,
        Math.round(maxW || ref.width || containerRect?.width || layout.totalWidth || 0)
      );

      const container = root.querySelector('.VtlsValueIconsContainer');
      if (container) {
        container.style.setProperty('padding-left', `${offsetInSection}px`, 'important');
        container.style.setProperty('padding-right', '0', 'important');
        container.style.setProperty('max-width', '100%', 'important');
        container.style.setProperty('box-sizing', 'border-box', 'important');
      }

      list.style.setProperty('display', 'block', 'important');
      list.style.setProperty('position', 'relative', 'important');
      list.style.setProperty('width', `${listWidth}px`, 'important');
      list.style.setProperty('max-width', `${listWidth}px`, 'important');
      list.style.setProperty('box-sizing', 'border-box', 'important');
      list.style.setProperty('flex-flow', 'unset', 'important');
      list.style.setProperty('justify-content', 'unset', 'important');
      list.style.setProperty('gap', '0', 'important');
      list.style.setProperty('padding', '0', 'important');
      list.style.setProperty('margin-left', '0', 'important');
      list.style.setProperty('margin-right', 'auto', 'important');

      const placeBlock = (block, slot, widen) => {
        if (!block || !slot) return;
        const leftInList = Math.round(slot.centerX - trackLeft);
        const tileW = Math.round(slot.tileWidth);
        const maxW = widen
          ? Math.max(360, Math.min(520, tileW + 160))
          : Math.max(280, Math.min(440, tileW));
        block.style.setProperty('position', 'absolute', 'important');
        block.style.setProperty('left', `${leftInList}px`, 'important');
        block.style.setProperty('top', '0', 'important');
        block.style.setProperty('transform', 'translateX(-50%)', 'important');
        block.style.setProperty('width', 'auto', 'important');
        block.style.setProperty('max-width', `${maxW}px`, 'important');
        block.style.setProperty('flex', 'none', 'important');
        block.style.setProperty('margin', '0', 'important');
      };

      placeBlock(blockLeft, slotLeft, true);
      placeBlock(blockRight, slotRight, true);

      const listHeight = Math.max(
        blockLeft.offsetHeight || 0,
        blockRight.offsetHeight || 0,
        1
      );
      list.style.setProperty('min-height', `${listHeight}px`, 'important');

      root.classList.add('nicha-pierres-aligned');
      root.classList.add('nicha-pierres-icons');
    };

    applyAligned();
    requestAnimationFrame(() => {
      applyAligned();
      requestAnimationFrame(applyAligned);
    });
  };

  window.NichaAlignPierresUnderGallery = alignValueIconsUnderGallery;

  const PIERRES_MOBILE_STACK_ID = 'nicha-pierres-mobile-stack';
  const pierresMobilePlacements = new Map();
  const pierresGalleryItemBackups = new WeakMap();

  const rememberPierresNode = (node) => {
    if (!node || pierresMobilePlacements.has(node)) return;
    pierresMobilePlacements.set(node, {
      parent: node.parentNode,
      next: node.nextSibling,
    });
  };

  const safeInsertChild = (parent, node, ref) => {
    if (!parent || !node) return;
    if (node.parentNode === parent) return;
    if (ref && ref.parentNode === parent) {
      parent.insertBefore(node, ref);
      return;
    }
    parent.appendChild(node);
  };

  const restorePierresNode = (node) => {
    const ref = pierresMobilePlacements.get(node);
    if (!ref?.parent?.isConnected) return;
    safeInsertChild(ref.parent, node, ref.next);
  };

  const isPrimaryProductGallery = (gallery) =>
    gallery &&
    (gallery.classList.contains('nicha-gallery--primary') ||
      gallery.getAttribute('data-nicha-primary-gallery') === 'true');

  const isPierresGallerySection = (section) => {
    const gallery = section?.querySelector('vtls-media-gallery');
    return gallery && !isPrimaryProductGallery(gallery);
  };

  const rememberGalleryItemForRowSplit = (item) => {
    if (pierresGalleryItemBackups.has(item)) return;
    pierresGalleryItemBackups.set(item, {
      parent: item.parentNode,
      next: item.nextSibling,
      width: item.style.width,
      height: item.style.height,
      left: item.style.left,
      top: item.style.top,
      position: item.style.position,
    });
  };

  const restoreGalleryItemFromRowSplit = (item) => {
    const backup = pierresGalleryItemBackups.get(item);
    clearMobileImageItemStyles(item);
    const lifestyle = findLifestyleMediaGallery();
    const list = lifestyle?.querySelector('.VtlsMediaGalleryImages');
    const targetParent =
      backup?.parent?.isConnected ? backup.parent : list;
    if (!targetParent) return;

    if (backup && isPierresDesktopViewport()) {
      item.style.width = backup.width;
      item.style.height = backup.height;
      item.style.left = backup.left;
      item.style.top = backup.top;
      item.style.position = backup.position;
    }

    safeInsertChild(targetParent, item, backup?.next);
  };

  const applyMobileImageItemStyles = (item) => {
    item.classList.add('nicha-pierres-mobile-img-item');
    item.style.setProperty('position', 'relative', 'important');
    item.style.setProperty('left', '0', 'important');
    item.style.setProperty('top', '0', 'important');
    item.style.removeProperty('width');
    item.style.removeProperty('height');
  };

  const clearMobileImageItemStyles = (item) => {
    item.classList.remove('nicha-pierres-mobile-img-item');
    ['position', 'left', 'top', 'width', 'height', 'max-width', 'max-height'].forEach((prop) =>
      item.style.removeProperty(prop)
    );
  };

  const isPierresMobileViewport = () => window.matchMedia('(max-width: 991px)').matches;

  const applyMobileLifestyleFullWidth = (block) => {
    if (!block) return;
    block.querySelectorAll('.VtlsMediaGalleryImage, .VtlsMediaGalleryImage__Wrapper, a, img').forEach((el) => {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('max-height', 'none', 'important');
    });
  };

  const applyMobileStackListFix = (node) => {
    if (!node?.classList) return;
    if (
      node.classList.contains('VtlsValueIconsBlock') ||
      node.classList.contains('VtlsMediaGalleryImage')
    ) {
      node.style.setProperty('list-style', 'none', 'important');
      node.style.setProperty('list-style-type', 'none', 'important');
    }
  };

  const buildMobileImageBlock = (gallery, item, index) => {
    let block = gallery.querySelector(
      `.nicha-pierres-mobile-img-block[data-nicha-img-index="${index}"]`
    );
    if (!block) {
      block = document.createElement('div');
      block.className = 'nicha-pierres-mobile-img-block';
      block.dataset.nichaImgIndex = String(index);
      const track = document.createElement('div');
      track.className = 'nicha-pierres-mobile-img-block__track';
      block.appendChild(track);
      rememberPierresNode(block);
    }
    const track = block.querySelector('.nicha-pierres-mobile-img-block__track');
    rememberGalleryItemForRowSplit(item);
    rememberPierresNode(item);
    track.appendChild(item);
    applyMobileImageItemStyles(item);
    return block;
  };

  const splitGalleryIntoRowBlocks = (gallery) => {
    const items = [...gallery.querySelectorAll('.VtlsMediaGalleryImage')];
    if (items.length < 2) return [];

    const rowGroups = new Map();
    items.forEach((item) => {
      const top = Math.round(parseFloat(item.style.top) || item.offsetTop || 0);
      if (!rowGroups.has(top)) rowGroups.set(top, []);
      rowGroups.get(top).push(item);
    });

    const sortedRows = [...rowGroups.entries()].sort((a, b) => a[0] - b[0]);
    if (sortedRows.length < 2) return [];

    return sortedRows.slice(0, 2).map(([, rowItems], rowIdx) => {
      let rowWrap = gallery.querySelector(`.nicha-pierres-mobile-row[data-nicha-row="${rowIdx}"]`);
      if (!rowWrap) {
        rowWrap = document.createElement('div');
        rowWrap.className = 'nicha-pierres-mobile-row';
        rowWrap.dataset.nichaRow = String(rowIdx);
        const track = document.createElement('div');
        track.className = 'nicha-pierres-mobile-row__track';
        rowItems.forEach((item) => {
          rememberGalleryItemForRowSplit(item);
          rememberPierresNode(item);
          track.appendChild(item);
          applyMobileImageItemStyles(item);
        });
        rowWrap.appendChild(track);
        rememberPierresNode(rowWrap);
      }
      return rowWrap;
    });
  };

  const findPierresMobileImageBlocks = (valueSection) => {
    const lifestyle = findLifestyleMediaGallery();
    if (lifestyle) {
      const items = [...lifestyle.querySelectorAll('.VtlsMediaGalleryImage')];
      if (items.length >= 2) {
        const imgTop =
          findLifestyleImageByHandles(items, LIFESTYLE_IMG_CHAIN_HANDLES) || items[0];
        const imgBottom =
          findLifestyleImageByHandles(items, LIFESTYLE_IMG_COLLIER_HANDLES) || items[1];
        return [
          buildMobileImageBlock(lifestyle, imgTop, items.indexOf(imgTop)),
          buildMobileImageBlock(lifestyle, imgBottom, items.indexOf(imgBottom)),
        ];
      }
    }

    const sections = [
      ...document.querySelectorAll('#MainContent .shopify-section, main .shopify-section'),
    ];
    const valueIdx = sections.findIndex(
      (s) => s.id === valueSection.id || s.contains(valueSection)
    );
    if (valueIdx < 0) return [];

    const gallerySections = sections.slice(0, valueIdx).filter(isPierresGallerySection);
    if (gallerySections.length >= 2) {
      return [
        gallerySections[gallerySections.length - 2],
        gallerySections[gallerySections.length - 1],
      ];
    }

    if (gallerySections.length === 1) {
      const section = gallerySections[0];
      const galleries = [...section.querySelectorAll('vtls-media-gallery')].filter(
        (g) => !isPrimaryProductGallery(g)
      );
      if (galleries.length >= 2) return [galleries[0], galleries[1]];

      const gallery = galleries[0];
      if (gallery) {
        const rowBlocks = splitGalleryIntoRowBlocks(gallery);
        if (rowBlocks.length >= 2) return rowBlocks;
      }
    }

    return [];
  };

  const getPierresValueSection = (root) =>
    root?.closest('.shopify-section') ||
    document.getElementById(VALUE_ICONS_SECTION_ID);

  const restorePierresMobileStack = () => {
    const stack = document.getElementById(PIERRES_MOBILE_STACK_ID);
    const root = findValueIconsPierresRoot();
    const valueSection = getPierresValueSection(root);
    const list = root?.querySelector('.VtlsValueIconsList');

    if (stack) {
      const nodes = [...stack.children];
      nodes.forEach((node) => {
        try {
          if (
            node.classList?.contains('nicha-pierres-mobile-row') ||
            node.classList?.contains('nicha-pierres-mobile-img-block')
          ) {
            node.querySelectorAll('.VtlsMediaGalleryImage').forEach(restoreGalleryItemFromRowSplit);
            node.remove();
            return;
          }
          if (node.classList?.contains('VtlsValueIconsBlock')) {
            node.style.removeProperty('display');
          }
          restorePierresNode(node);
        } catch (err) {
          console.warn('Nicha: restore mobile stack node skipped', err);
        }
      });
      stack.remove();
    }

    document.querySelectorAll('.nicha-pierres-gallery-hidden').forEach((el) => {
      el.classList.remove('nicha-pierres-gallery-hidden');
      el.style.removeProperty('display');
    });

    if (list) list.style.removeProperty('display');
    valueSection?.classList.remove('nicha-pierres-mobile-stacked');
    document.body.classList.remove('nicha-pierres-mobile-active');

    pierresMobilePlacements.clear();
  };

  const refreshPierresDesktopLayout = () => {
    if (isPierresMobileViewport()) return;
    applyDesktopPierresLayout();
  };

  /** Mobile : image haut → chaîne → image bas → collier */
  const initPierresMobileStack = () => {
    if (!isPierresMobileViewport()) {
      restorePierresMobileStack();
      applyDesktopPierresLayout();
      return;
    }

    restorePierresMobileStack();

    const root = findValueIconsPierresRoot();
    const valueSection = getPierresValueSection(root);
    if (!valueSection || !root) return;

    const blocks = [...root.querySelectorAll('.VtlsValueIconsBlock')];
    const blockLeft = findPierresBlockChain(blocks);
    const blockRight = findPierresBlockCollier(blocks);
    if (!blockLeft || !blockRight) return;

    const imageBlocks = findPierresMobileImageBlocks(valueSection);
    if (imageBlocks.length < 2) return;

    const topBlock = imageBlocks[0];
    const bottomBlock = imageBlocks[1];

    let stack = document.getElementById(PIERRES_MOBILE_STACK_ID);
    if (!stack) {
      stack = document.createElement('div');
      stack.id = PIERRES_MOBILE_STACK_ID;
      stack.className = 'nicha-pierres-mobile-stack';
    }

    const lifestyleSection = findLifestyleMediaGallery()?.closest('.shopify-section');
    const anchor = lifestyleSection || valueSection;
    const anchorParent = anchor.parentNode;
    if (!anchorParent) return;

    if (stack.parentNode !== anchorParent) {
      anchorParent.insertBefore(stack, anchor);
    }

    const ordered = [topBlock, blockLeft, bottomBlock, blockRight];
    ordered.forEach((node) => {
      rememberPierresNode(node);
      applyMobileStackListFix(node);
      if (node.classList?.contains('nicha-pierres-mobile-img-block')) {
        applyMobileLifestyleFullWidth(node);
      }
      stack.appendChild(node);
    });

    if (lifestyleSection) {
      lifestyleSection.classList.add('nicha-pierres-gallery-hidden');
      lifestyleSection.style.setProperty('display', 'none', 'important');
    }

    const list = root.querySelector('.VtlsValueIconsList');
    if (list) list.style.setProperty('display', 'none', 'important');
    valueSection.classList.add('nicha-pierres-mobile-stacked');
    document.body.classList.add('nicha-pierres-mobile-active');
    root.querySelectorAll('.VtlsValueIconsBlock__Description').forEach((p) => {
      delete p.dataset.nichaPierresDescFormatted;
    });
    root.querySelectorAll('.VtlsValueIconsBlock__Description').forEach(formatPierresDescription);
  };

  let pierresMobileMqBound = false;
  const bindPierresMobileMediaQuery = () => {
    if (pierresMobileMqBound) return;
    pierresMobileMqBound = true;
    const mq = window.matchMedia('(max-width: 991px)');
    const onChange = () => {
      if (mq.matches) initValueIconsPierres();
      else applyDesktopPierresLayout();
    };
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
    else if (typeof mq.addListener === 'function') mq.addListener(onChange);
  };

  const watchPierresMobileStack = () => {
    bindPierresMobileMediaQuery();
  };

  window.NichaPierresMobileStack = initPierresMobileStack;

  const applyLifestyleMediaGalleryGap = (gallery) => {
    if (!gallery) return;

    const items = [...gallery.querySelectorAll('.VtlsMediaGalleryImage')];
    if (items.length < 2) return;

    const mobile = window.matchMedia('(max-width: 991px)').matches;
    if (mobile) {
      if (gallery.classList.contains('nicha-lifestyle-gallery--wide-gap')) {
        resetLifestyleMediaGallery(gallery, { clearBase: true });
      }
      return;
    }

    delete gallery.dataset.nichaLifestyleBaseTileW;
    delete gallery.dataset.nichaLifestyleBaseTileH;

    syncPierresDesktopTrackOnly();
    syncLifestyleGalleryContainerWithPrimary(gallery);

    const targetGap = LIFESTYLE_GALLERY_GAP_DESKTOP;
    const cols = Number(gallery.getAttribute('data-columns-desktop')) || 2;

    const first = items[0];
    const list = gallery.querySelector('.VtlsMediaGalleryImages');
    const base = getLifestyleGalleryBaseTile(gallery, first, list, cols);
    if (!base.w) return;

    const fitted = fitLifestyleGalleryDimensions(
      gallery,
      base.w,
      base.h,
      targetGap,
      cols
    );
    const { tileWidth, tileHeight, gap, scale, totalWidth, maxW } = fitted;
    if (!tileWidth || !maxW) return;

    items.forEach((item, index) => {
      const col = index % cols;
      const row = Math.floor(index / cols);
      item.style.setProperty('width', `${tileWidth}px`, 'important');
      item.style.setProperty('height', `${tileHeight}px`, 'important');
      item.style.setProperty('left', `${col * (tileWidth + gap)}px`, 'important');
      item.style.setProperty('top', `${row * (tileHeight + gap)}px`, 'important');
    });

    if (list) {
      const rowCount = Math.ceil(items.length / cols);
      const totalHeight = rowCount * tileHeight + Math.max(0, rowCount - 1) * gap;
      list.style.setProperty('height', `${Math.round(totalHeight)}px`, 'important');
      list.style.setProperty('width', `${Math.round(totalWidth)}px`, 'important');
      list.style.setProperty('max-width', '100%', 'important');
      list.style.setProperty('margin-left', '0', 'important');
      list.style.setProperty('margin-right', 'auto', 'important');
      list.style.setProperty('overflow', 'visible', 'important');
    }

    gallery.classList.add('nicha-lifestyle-gallery--wide-gap');
    gallery.dataset.nichaLifestyleGap = String(Math.round(gap));
    gallery.dataset.nichaLifestyleScale = String(scale);
    gallery.dataset.nichaLifestyleTileW = String(Math.round(tileWidth));
    gallery.dataset.nichaLifestyleTrackW = String(Math.round(totalWidth));
  };

  const initLifestyleMediaGalleryGap = () => {
    if (!isNichaHomepage()) return;
    injectLifestyleGalleryFitStyles();
    const gallery = findLifestyleMediaGallery();
    if (!gallery) {
      if (!window.__nichaLifestyleMissingWarned) {
        window.__nichaLifestyleMissingWarned = true;
        console.warn('[Nicha] Galerie lifestyle kufxj7 introuvable sur la page');
      }
      return;
    }
    if (!window.matchMedia('(min-width: 992px)').matches) return;
    const run = () => {
      if (findPrimaryProductGallery()) applyLifestyleMediaGalleryGap(gallery);
    };
    run();
    [250, 800, 2000, 3500].forEach((d) => setTimeout(run, d));
  };

  window.NichaLifestyleGalleryGap = initLifestyleMediaGalleryGap;

  let valueIconsObserverStarted = false;
  const watchValueIconsPierres = () => {
    if (valueIconsObserverStarted || typeof MutationObserver === 'undefined') return;
    const root = findValueIconsPierresRoot();
    if (!root) return;
    valueIconsObserverStarted = true;
    let debounce;
    const mo = new MutationObserver(() => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const r = findValueIconsPierresRoot();
        if (!r) return;
        forceAllPierresTitles(r);
        r.querySelectorAll('.VtlsValueIconsBlock__Description').forEach(formatPierresDescription);
      }, 200);
    });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
  };

  // ============================================
  // PAGE PRODUIT — classe body (LayoutHub n'ajoute pas template-product)
  // ============================================
  const ensureProductPageBodyClass = () => {
    const isProductPage =
      /\/products\//.test(window.location.pathname || '') ||
      document.querySelector('section.page-width[class*="main-padding"] .product') ||
      document.querySelector('.product__media-gallery') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!isProductPage) return;

    document.body.classList.add('template-product', 'nicha-product-page');
    document.documentElement.classList.add('template-product');

    document.documentElement.style.removeProperty('--nicha-pierres-track-width');
    document.documentElement.style.removeProperty('--nicha-pierres-track-offset');
    document.documentElement.style.removeProperty('--nicha-pierres-section-width');

    injectProductPageLayoutStyles();
  };

  const injectProductPageLayoutStyles = () => {
    let style = document.getElementById('nicha-product-layout-fix');
    if (!style) {
      style = document.createElement('style');
      style.id = 'nicha-product-layout-fix';
      document.head.appendChild(style);
    }
    style.textContent = `
      section.page-width[class*="main-padding"],
      .shopify-section[id*="__main"] > section.page-width[class*="main-padding"] {
        width: 100% !important;
        max-width: min(calc(100vw - 3rem), var(--page-width, 100%)) !important;
        margin-left: auto !important;
        margin-right: auto !important;
        padding-left: 1.5rem !important;
        padding-right: 1.5rem !important;
        box-sizing: border-box !important;
      }
      @media (min-width: 750px) {
        section.page-width[class*="main-padding"] .product.product--large:not(.product--no-media) .product__media-wrapper,
        section.page-width[class*="main-padding"] .product.product--large:not(.product--no-media) .product__info-wrapper {
          flex: 0 0 calc(50% - var(--grid-desktop-horizontal-spacing, 2rem) / 2) !important;
          max-width: calc(50% - var(--grid-desktop-horizontal-spacing, 2rem) / 2) !important;
          width: calc(50% - var(--grid-desktop-horizontal-spacing, 2rem) / 2) !important;
        }
        section.page-width[class*="main-padding"] .product__media-wrapper {
          min-width: 0 !important;
          overflow-x: hidden !important;
        }
        section.page-width[class*="main-padding"] .product.grid {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          column-gap: var(--grid-desktop-horizontal-spacing, 2rem) !important;
          gap: var(--grid-desktop-horizontal-spacing, 2rem) !important;
        }
        section.page-width[class*="main-padding"] .product__media-list {
          display: block !important;
          overflow: visible !important;
          width: 100% !important;
          margin-left: 0 !important;
        }
        section.page-width[class*="main-padding"] .product--thumbnail_slider .product__media-item:not(.is-active) {
          display: none !important;
        }
        section.page-width[class*="main-padding"] .product__media-item {
          flex: none !important;
          min-width: 0 !important;
          width: 100% !important;
        }
        section.page-width[class*="main-padding"] .product__media-wrapper .thumbnail-slider,
        section.page-width[class*="main-padding"] .product__media-gallery .thumbnail-slider {
          display: flex !important;
          width: 100% !important;
          max-width: 100% !important;
          margin-left: 0 !important;
          margin-right: 0 !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
          box-sizing: border-box !important;
        }
        section.page-width[class*="main-padding"] .thumbnail-slider slider-component,
        section.page-width[class*="main-padding"] .thumbnail-slider.slider-mobile-gutter {
          margin-left: 0 !important;
          margin-right: 0 !important;
          max-width: 100% !important;
          width: 100% !important;
        }
      }
      @media (min-width: 990px) {
        section.page-width[class*="main-padding"],
        .shopify-section[id*="__main"] > section.page-width[class*="main-padding"] {
          max-width: min(calc(100vw - 6rem), 1920px) !important;
          padding-left: clamp(2rem, 4vw, 4rem) !important;
          padding-right: clamp(2rem, 4vw, 4rem) !important;
        }
      }
      @media (max-width: 749px) {
        section.page-width[class*="main-padding"] .product__media-list {
          display: flex !important;
          flex-direction: row !important;
          overflow-x: auto !important;
        }
        section.page-width[class*="main-padding"] .product__media-item {
          flex: 0 0 100% !important;
          min-width: 100% !important;
        }
        section.page-width[class*="main-padding"] .thumbnail-slider {
          display: none !important;
        }
      }
    `;
  };

  window.NichaProductPageLayout = {
    refresh: () => {
      ensureProductPageBodyClass();
    },
  };

  // ============================================
  // INITIALISATION
  // ============================================
  
  const init = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    try {
    ensureHomepageBodyClass();
    injectHomepageHeaderDesktopStyles();
    initHomepageHeaderDesktopLayout();
    [400, 1200, 3000].forEach((d) => setTimeout(initHomepageHeaderDesktopLayout, d));
    injectHomepageDesktopFontStyles();
    injectHomepageSlideshowMobileStyles();
    applyHomepageSlideshowMobileCrop();
    [200, 600, 1500, 3000].forEach((d) => setTimeout(applyHomepageSlideshowMobileCrop, d));
    ensureProductPageBodyClass();
    [100, 400, 1200].forEach((d) => setTimeout(ensureProductPageBodyClass, d));
    initCartAddInterceptor();
    initScrollAnimations();
    initPreorderCalculator();
    initProductGallery();
    if (window.NichaSquareMediaGallery && typeof window.NichaSquareMediaGallery.scan === 'function') {
      const runGalleryScan = () => window.NichaSquareMediaGallery.scan().catch(() => {});
      runGalleryScan();
      [500, 1500, 3000].forEach((d) => setTimeout(runGalleryScan, d));
    }
    initValueIconsPierres();
    watchValueIconsPierres();
    watchPierresMobileStack();
    initLifestyleMediaGalleryGap();
    [300, 800, 1500, 3000, 6000].forEach((d) => setTimeout(initValueIconsPierres, d));
    [400, 1000, 2000, 3500].forEach((d) => setTimeout(applyDesktopPierresLayout, d));
    window.addEventListener('resize', () => {
      clearTimeout(window.__nichaPierresAlignTimer);
      window.__nichaPierresAlignTimer = setTimeout(() => {
        applyHomepageSlideshowMobileCrop();
        injectHomepageHeaderDesktopStyles();
        initHomepageHeaderDesktopLayout();
        if (window.matchMedia('(max-width: 991px)').matches) initValueIconsPierres();
        else applyDesktopPierresLayout();
        const pierresRoot = findValueIconsPierresRoot();
        if (pierresRoot) {
          pierresRoot.querySelectorAll('.VtlsValueIconsBlock__Description').forEach((p) => {
            delete p.dataset.nichaPierresDescFormatted;
          });
          pierresRoot.querySelectorAll('.VtlsValueIconsBlock__Description').forEach(formatPierresDescription);
        }
      }, 200);
    });
    document.addEventListener('nicha:primary-gallery-layout', () => {
      if (window.matchMedia('(min-width: 992px)').matches) applyDesktopPierresLayout();
    });
    initProductUniformMediaFrames();
    [100, 500, 1500, 3000].forEach((d) => setTimeout(initProductUniformMediaFrames, d));
    initProductMainGallerySlider();
    [100, 500, 1500, 3000].forEach((d) => setTimeout(initProductMainGallerySlider, d));
    [200, 800].forEach((d) => setTimeout(initThumbnailStripSlider, d));
    initProductMediaModalFix();
    [100, 500, 1500].forEach((d) => setTimeout(initProductMediaModalFix, d));
    initProductMobileImageTitleSpacing();
    [100, 400, 1000].forEach((d) => setTimeout(() => { if (typeof applyProductMobileImageTitleSpacing === 'function') applyProductMobileImageTitleSpacing(); }, d));
    applyProductInfoBlockSpacing();
    [200, 600, 1200, 2500].forEach((d) => setTimeout(applyProductInfoBlockSpacing, d));
    window.addEventListener('resize', () => setTimeout(applyProductInfoBlockSpacing, 100));
    const productInfo = document.querySelector('.product__info-wrapper, [id*="ProductInfo"]');
    if (productInfo && typeof MutationObserver !== 'undefined') {
      let debounce;
      const mo = new MutationObserver(() => {
        clearTimeout(debounce);
        debounce = setTimeout(applyProductInfoBlockSpacing, 150);
      });
      mo.observe(productInfo, { childList: true, subtree: true });
    }
    initProductTitleShareRow();
    [100, 400].forEach((d) => setTimeout(initProductTitleShareRow, d));
    initProductVendorSpacing();
    [200, 600].forEach((d) => setTimeout(initProductVendorSpacing, d));
    initMulticolumnOverlapFix();
    applyProductMediaGapFix();
    [300, 800, 1500].forEach((d) => setTimeout(() => { initMulticolumnOverlapFix(); applyProductMediaGapFix(); }, d));
    window.addEventListener('resize', () => { setTimeout(initMulticolumnOverlapFix, 50); setTimeout(applyProductMediaGapFix, 100); });
    window.addEventListener('resize', () => setTimeout(initProductVendorSpacing, 100));
    initStockCounter();
    initSmoothScroll();
    initLazyLoading();
    initMobileMenu();
    watchAndHideSmartsizeBlock();
    initSmartsizePlacement();
    retrySmartsizePlacement();
    initCustomMeasurementField();
    injectKlarnaStyles();
    injectCollectionFontStyles();
    enlargeCollectionFonts();
    loadKlarnaScript(() => {
      initKlarnaPlacement();
      injectKlarnaShadowStyles();
      [300, 800, 1500].forEach((d) => setTimeout(injectKlarnaShadowStyles, d));
    });
    
    setTimeout(enlargeCollectionFonts, 500);
    setTimeout(enlargeCollectionFonts, 1500);
    setTimeout(enlargeCollectionFonts, 3000);
    
    if (document.body && document.body.dataset.nichaCollectionFontObserver !== 'true') {
      document.body.dataset.nichaCollectionFontObserver = 'true';
      const fontObserver = new MutationObserver(() => {
        enlargeCollectionFonts();
      });
      fontObserver.observe(document.body, { childList: true, subtree: true });
      
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(enlargeCollectionFonts, 250);
      });
    }
    } catch (err) {
      console.error('[Nicha] custom-nicha init error — fichier peut-être tronqué à l\'upload', err);
    }
  };

  init();

  window.NICHA_CUSTOM_VERSION = '2026-06-03-fix45';
  if (typeof initValueIconsPierres === 'function') {
    console.info('[Nicha] custom-nicha.js pierres actif —', window.NICHA_CUSTOM_VERSION);
  } else {
    console.warn(
      '[Nicha] custom-nicha.js incomplet (~155 Ko attendu). Téléversez le fichier entier dans Shopify (Éditeur de thème → assets).'
    );
  }

  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
  }

})();

/* NICHA_CUSTOM_EOF 2026-06-03-fix45 — taille attendue ~155 Ko, pas ~52 Ko */
